import React, { useState, useRef, useEffect, useContext } from "react";
import "../../Master/SchemeRegistration/SchemeRegistration.css";
import "./SchemeCashReceipt.css";

import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import stngs from "../../../assets/images/whtsttngs.webp";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../../components/NavBars/ActionToolbar";
import GridDesign from "../../GridDesign/GridDesign";
import saveImg from "../../../assets/images/SaveImage.png";
import printImg from "../../../assets/images/Printer.png";
import clearImg from "../../../assets/images/Document.png";
import findImg from "../../../assets/images/search.png";
import editImg from "../../../assets/images/Editing.png";
import deleteImg from "../../../assets/images/Delete.png";
import exitImg from "../../../assets/images/Exit1.png";
import playandpause from "../../../assets/images/Play and pause button.png";
import leftarrow from "../../../assets/images/Play button arrowhead left.png";
import rightarrow from "../../../assets/images/Play button arrowhead right.png";
import playandpauseRight from "../../../assets/images/Play and pause button right.png";
import toggleClose from "../../../assets/images/xred.webp";
import close from "../../../assets/images/findclose.png";
import binImg from "../../../assets/images/Bin.png";

//import ComboBox from "shersoft-combov1";
import ComboBox from "../../../../src/components/ComboBoxes/ComboBox";
import axios from "axios";
import Swal from "sweetalert2";
import Print from "../../PrintModels/Print";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import PasswordVerification from "../../verificators/PasswordVerification";
import ImportReceipt from "./ImportReceipt";
import io from "socket.io-client";
import TransferVoucher from "../TransferVoucher/TransferVoucher";
import { useSelector } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import { selectGeneralSettings } from "../../../app/settingsSlice";
import { selectActiveLocation } from "../../../app/locationSlice";

import AdminVerification from "../../verificators/AdminVerification";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";
import { createGridKeyDownHandler } from "../../../utils/gridKeyDownHelper";

import { selectActiveFyid } from "../../../app/financialYearSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";
import { ToWords } from "to-words";
import { printWithTemplate, clearPrintTemplateCache } from "../../../hooks/usePrintService";

// ── Default Form Fields for Scheme Cash Receipt ──
const defaultSchemeFormFields = [
  // ── Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 0,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "SchemeName",
    fieldName: "Scheme Name",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashAccount",
    fieldName: "Cash Account",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Rate",
    fieldName: "Rate",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Scheme Receipt Grid",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 25,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 26,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 27,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 28,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 29,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 30,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 31,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_AccountNumber",
    fieldName: "Grid - Account Number",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  {
    fieldId: "grid_Amount",
    fieldName: "Grid - Amount",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Disc",
    fieldName: "Grid - Disc",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Total",
    fieldName: "Grid - Total",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Gm",
    fieldName: "Grid - Gm",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_DiscGm",
    fieldName: "Grid - Disc Gm",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_TotalGm",
    fieldName: "Grid - Total Gm",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Narration",
    fieldName: "Grid - Narration",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "AccountNumber",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "SaveBtn",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "Narration",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "AccountNumber",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

// Main export wrapper
function SchemeCashReceipt(props) {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const vType = props.voucherType || props.formName || "SCHEME RECEIPT";

  return (
    <FormDesignProvider
      formName={vType}
      defaultFields={defaultSchemeFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <SchemeCashReceiptInner {...props} />
    </FormDesignProvider>
  );
}

function SchemeCashReceiptInner({ onClose, formId, formName, voucherType, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;

  const { agentCode } = useContext(AuthContext);
  const permissions = useSelector(selectMenuPermissions);
  const GeneralSettings = useSelector(selectGeneralSettings);
  ////////////////////////////Genaral Settings filters/////////////////////////
  ////console.log("GeneralSettings==", GeneralSettings);

  const [roundOff, setRoundOff] = useState(3);
  const [amountDecimals, setAmountDecimals] = useState(2);

  const formatSmsAmount = (val) => {
    if (val === null || val === undefined || val === "") return "0.00";
    const num = parseFloat(String(val).replace(/,/g, ""));
    if (isNaN(num)) return "0.00";
    const dec = !isNaN(amountDecimals) && amountDecimals >= 0 ? amountDecimals : 2;
    return num.toFixed(dec);
  };

  const formatSmsWeight = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    const num = parseFloat(String(val).replace(/,/g, ""));
    if (isNaN(num)) return "0.000";
    const dec = !isNaN(roundOff) && roundOff >= 0 ? roundOff : 3;
    return num.toFixed(dec);
  };
  const [genValues, setGenValues] = useState({
    readonlyGrate: "",
    readonlyDate: "",
    sendwhatsappmsg: "",
  });

  useEffect(() => {
    const obj = GeneralSettings.find((item) => item.Name === "DECIMAL POINT");
    if (obj && obj.s_Value !== undefined && obj.s_Value !== "") {
      setRoundOff(parseInt(obj.s_Value, 10));
    }

    const objAmt = GeneralSettings.find((item) => item.Name === "DECIMAL POINT IN REPORT");
    if (objAmt && objAmt.s_Value !== undefined && objAmt.s_Value !== "") {
      setAmountDecimals(parseInt(objAmt.s_Value, 10));
    }

    // 2. Read-only rate field setting
    const grate = GeneralSettings.find(
      (item) =>
        item.Name === "READ ONLY RATE FIELD FOR EMPLOYEES IN SCHEME RECEIPT",
    );

    if (grate) {
      setGenValues((prev) => ({
        ...prev,
        readonlyGrate: grate.ss_status,
      }));
    }

    // 3. Read-only date field setting (
    const date = GeneralSettings.find(
      (item) =>
        item.Name === "READ ONLY DATE FIELD FOR EMPLOYEES IN SCHEME RECEIPT",
    );

    if (date) {
      setGenValues((prev) => ({
        ...prev,
        readonlyDate: date.ss_status,
      }));
    }
    // 4. enable whats app message on receipt
    const whatsapp = GeneralSettings.find(
      (item) => item.Name === "ENABLE WHATSAPP ON SCHEME RECEIPT",
    );

    if (whatsapp) {
      setGenValues((prev) => ({
        ...prev,
        sendwhatsappmsg: whatsapp.ss_status,
      }));
    }
  }, [GeneralSettings]);
  ////////////////////////////////////////////////////////////////////////////
  const [frmId, setfrmid] = useState(() => formId ? parseInt(formId) : 0);
  const [fname, setfname] = useState("");
  const [vType, setVType] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (formId) {
      setfrmid(parseInt(formId));
    }
    setfname(formName);
    setVType(voucherType);
  }, [formId, formName, voucherType]);
  // ////////////////////console.log("frmId===", frmId);

  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [userType, setuserType] = useState("");

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
    }
  }, []);
  const [userRights, setUserRights] = useState("");
  ////////console.log("userRights====", userRights);

  useEffect(() => {
    const storedRights = localStorage.getItem("uRights");
    if (storedRights) {
      try {
        const parsedRights = JSON.parse(storedRights);
        setUserRights(parsedRights);

        // Find the rights for the current form (Fid = frmId and Type = "SCHEME RECEIPT")
        const formRights = parsedRights.find(
          (right) => right.Fid === parseInt(frmId),
        );

        setUserRights(formRights || null); // Store the filtered rights
      } catch (error) {
        console.error("Error parsing user rights:", error);
        setUserRights([]);
      }
    }
  }, [frmId]);

  const [showPrintModel, setShowPrintModel] = useState(false);
  const [showsettings, setShowsettings] = useState(false);
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        if (!dbCode) return;
        const response = await axios.get(
          `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`
        );
        const foundData = response.data?.[0];
        if (foundData?.name) {
          setCompanyName(foundData.name);
        }
      } catch (error) {
        console.error("Error fetching company details:", error.message);
      }
    };
    fetchCompanyDetails();
  }, [apiBaseUrl, dbCode]);

  const [showImportRec, setShowImportRec] = useState(false);
  const [showTransfervoucher, setShowTransfervoucher] = useState(false);

  const [printData, setPrintData] = useState(null);

  const handleClosePrint = () => {
    setShowPrintModel(false);
  };
  const [startDate, setStartDate] = useState(new Date());
  /////////////table///////////
  const tableContainerRef = useRef(null);
  const cashaccref = useRef(null);

  const entryNoInputRef = useRef(null);
  const cashaccinputRef = useRef(null);
  const schemIdinputRef = useRef(null);

  const rateInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const editButtonRef = useRef(null);
  const salesmanRef = useRef(null);

  const createEmptyRow = () => ({
    SINo: "",
    name: "",
    agent: "",
    accountNumber: "",
    amount: "",
    disc: "",
    total: "",
    gm: "",
    discGm: "",
    totalGm: "",
    narration: "",
    printgm: "",
    billed: "",
    schemeId: "",
  });

  const createEmptyRows = (count = 14) =>
    Array.from({ length: count }, () => createEmptyRow());

  const addRow = () => {
    // ////////////////////console.log("add row called");
    setTableData((prev) => [...prev, createEmptyRow()]);
  };

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);

  const handleScroll = () => {
    const tableContainer = tableContainerRef.current;
    if (
      tableContainer.scrollTop + tableContainer.clientHeight >=
      tableContainer.scrollHeight - 1
    ) {
      // User has scrolled to the bottom, add new rows
      addRow();
    }
  };

  //////////current date///////////

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY bounds
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  ////////////////////////// form data states //////////

  const [tableData, setTableData] = useState(createEmptyRows(14));

  const defaultSchemeGridColumns = [
    {
      sNo: 1,
      columnName: "Slno",
      width: 35,
      orderNo: 0,
      header: "SI No",
      show: true,
    },
    {
      sNo: 2,
      columnName: "ItemName",
      width: 130,
      orderNo: 1,
      header: "Name",
      show: true,
    },
    {
      sNo: 3,
      columnName: "Agent",
      width: 90,
      orderNo: 2,
      header: "Agent",
      show: true,
    },
    {
      sNo: 4,
      columnName: "AccountNumber",
      width: 100,
      orderNo: 3,
      header: "Account Number",
      show: true,
    },
    {
      sNo: 5,
      columnName: "Amount",
      width: 65,
      orderNo: 4,
      header: "Amount",
      show: true,
    },
    {
      sNo: 6,
      columnName: "Disc",
      width: 65,
      orderNo: 5,
      header: "Disc",
      show: true,
    },
    {
      sNo: 7,
      columnName: "Total",
      width: 65,
      orderNo: 6,
      header: "Total",
      show: true,
    },
    {
      sNo: 8,
      columnName: "Gm",
      width: 65,
      orderNo: 7,
      header: "Gm",
      show: true,
    },
    {
      sNo: 9,
      columnName: "DiscGm",
      width: 65,
      orderNo: 8,
      header: "Disc Gm",
      show: true,
    },
    {
      sNo: 10,
      columnName: "TotalGm",
      width: 65,
      orderNo: 9,
      header: "Total Gm",
      show: true,
    },
    {
      sNo: 11,
      columnName: "Narration",
      width: 120,
      orderNo: 10,
      header: "Narration",
      show: true,
    },
    {
      sNo: 12,
      columnName: "PrintGm",
      width: 50,
      orderNo: 11,
      header: "Print Gm",
      show: true,
    },
  ];

  const [gridColumns, setGridColumns] = useState(defaultSchemeGridColumns);
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);
  const [showFormDesignModal, setShowFormDesignModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  // ── FormDesign hook ──
  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
    breakoutColumn,
    setRowBreakColumn,
    setRowBreakTarget,
    setBreakoutColumn,
    setBreakoutTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;

      // Check Local Storage first
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          const itemNameCol = parsed.find((c) => c.columnName === "ItemName");
          if (itemNameCol && itemNameCol.width !== 130) {
            localStorage.removeItem(`grid_design_${vType}`);
            cached = null;
          } else {
            setGridColumns(parsed);
            return;
          }
        } catch (e) {
          console.error("Error parsing cached grid settings:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
        );
        const dbCols = response.data.recordset || response.data || [];
        if (dbCols.length > 0) {
          const merged = defaultSchemeGridColumns.map((initCol) => {
            const dbMatch = dbCols.find(
              (c) =>
                String(c.ColName).toLowerCase() ===
                String(initCol.columnName).toLowerCase(),
            );
            if (dbMatch) {
              return {
                ...initCol,
                width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
                orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
                header: dbMatch.Header || initCol.header,
                show: dbMatch.Vis === 1,
              };
            }
            return initCol;
          });
          merged.sort((a, b) => a.orderNo - b.orderNo);
          localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));
          setGridColumns(merged);
        }
      } catch (error) {
        console.error("Error loading grid settings:", error);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, vType]);

  const getColWidth = (colName) => {
    const col = gridColumns.find((c) => c.columnName === colName);
    return col && col.show ? col.width : 0;
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      localStorage.removeItem(`grid_design_${vType}`);
      const response = await axios.get(
        `${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`,
      );
      const dbCols = response.data.recordset || response.data || [];
      if (dbCols.length > 0) {
        const merged = defaultSchemeGridColumns.map((initCol) => {
          const dbMatch = dbCols.find(
            (c) =>
              String(c.ColName).toLowerCase() ===
              String(initCol.columnName).toLowerCase(),
          );
          if (dbMatch) {
            return {
              ...initCol,
              width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
              orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
              header: dbMatch.Header || initCol.header,
              show: dbMatch.Vis === 1,
            };
          }
          return initCol;
        });
        merged.sort((a, b) => a.orderNo - b.orderNo);
        localStorage.setItem(`grid_design_${vType}`, JSON.stringify(merged));
        setGridColumns(merged);
      } else {
        setGridColumns(defaultSchemeGridColumns);
      }
    } catch (error) {
      console.error("Error refreshing grid settings:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  console.log("tableData==", tableData);



  // ── Dynamic Print: builds flat token data object from current form state ──
  const _toWords = new ToWords({ localeCode: "en-IN" });

  const formatPrintDate = (dateStr) => {
    try {
      const d = new Date(dateStr);
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return new Intl.DateTimeFormat("en-GB", options).format(d).replace(/ /g, "/");
    } catch (_) { return dateStr || ""; }
  };

  const buildPrintData = (rowIndex, extraData = {}) => {
    const row = tableData[rowIndex] || {};
    const totalAmt = parseFloat(row.total || row.amount || 0);
    const amtStr = totalAmt > 0 ? String(totalAmt) : "";
    let amtWords = "";
    try { amtWords = totalAmt > 0 ? _toWords.convert(totalAmt) : ""; } catch (_) {}

    const currentWeight = parseFloat(row.totalGm || row.gm || 0);
    const oldWt = extraData.oldWeight !== undefined ? extraData.oldWeight : (parseFloat(dispWt || 0) || "");
    const totWt = extraData.totalWeight !== undefined ? extraData.totalWeight : (
      (parseFloat(oldWt || 0) + currentWeight) > 0 
        ? (parseFloat(oldWt || 0) + currentWeight).toFixed(3) 
        : (schemeRecInfoData.totalTotalGm || currentWeight || "")
    );
    const oldBal = extraData.oldBalance !== undefined ? extraData.oldBalance : (dispTm || "");
    const closeBal = extraData.closingBalance !== undefined ? extraData.closingBalance : (
      (parseFloat(oldBal || 0) + totalAmt).toFixed(2)
    );

    return {
      VoucherNo:      `${schemeRecInfoData.EntryNo || ""} -${(Array.isArray(row.agent) ? row.agent[1] : row.agent || "").substring(0, 3)}`,
      Date:           formatPrintDate(schemeRecInfoData.date),
      AccountNo:      Array.isArray(row.accountNumber) ? (row.accountNumber[1] || "") : (row.accountNumber || ""),
      CustomerName:   Array.isArray(row.name) ? (row.name[1] || "") : (row.name || ""),
      TotalAmount:    amtStr,
      AmountInWords:  amtWords,
      PaymentMode:    "CASH",
      Rate:           String(schemeRecInfoData.rate || ""),
      OldWeight:      oldWt !== "" ? String(oldWt) : "",
      Weight:         currentWeight > 0 ? String(currentWeight) : String(row.totalGm || row.gm || ""),
      TotalWeight:    String(totWt || ""),
      SchemeName:     Array.isArray(schemeRecInfoData.schemeId) ? (schemeRecInfoData.schemeId[1] || "") : (schemeRecInfoData.schemeId || ""),
      CashAccount:    Array.isArray(schemeRecInfoData.cashAcc) ? (schemeRecInfoData.cashAcc[1] || "") : (schemeRecInfoData.cashAcc || ""),
      AgentName:      Array.isArray(row.agent) ? (row.agent[1] || "") : (row.agent || ""),
      SalesMan:       Array.isArray(schemeRecInfoData.salesMan) ? (schemeRecInfoData.salesMan[1] || "") : (schemeRecInfoData.salesMan || ""),
      OldBalance:     oldBal !== "" ? String(oldBal) : "",
      ClosingBalance: String(closeBal),
      TotalPaidAmount: String(closeBal),
      CompanyName:    companyName || "",
    };
  };

  // ── Unified action handler: print / download / fallback ──
  const [isPrintLoading, setIsPrintLoading] = useState(false);

  const handleDynamicAction = async (action) => {
    const slno = parseInt(selectedSlNo);
    const slnoLimit = handleCheckSlno();
    if (!slno || slno > slnoLimit || slno <= 0) {
      Swal.fire({ icon: "warning", title: "Invalid Sl No", text: "Please enter a valid Sl No to print.", timer: 2000, showConfirmButton: false });
      return;
    }

    const rowIndex = slno - 1;
    const row = tableData[rowIndex] || {};
    const ledCode = Array.isArray(row.name) ? row.name[0] : (row.name?.value ?? row.name?.Ledcode ?? row.name);
    const currentWeight = parseFloat(row.totalGm || row.gm || 0);
    const currentAmount = parseFloat(row.total || row.amount || 0);
    const currentEntryNo = schemeRecInfoData.EntryNo;
    const currentFrmId = frmId;

    let extraData = {};
    if (ledCode) {
      try {
        const res = await axios.get(
          `${apiBaseUrl}/main/recbalances/${ledCode}/${dbCode}?entryNo=${currentEntryNo}&frmId=${currentFrmId}`
        );
        if (res.data && res.data[0]) {
          const b = res.data[0];
          const isSaved = b.isSaved === 1 || b.isSaved === true;
          if (isSaved) {
            extraData = {
              oldWeight: parseFloat(b.oldWeight || 0).toFixed(3),
              totalWeight: parseFloat(b.totalWeight || 0).toFixed(3),
              oldBalance: parseFloat(b.oldBalance || 0).toFixed(2),
              closingBalance: parseFloat(b.totalBalance || 0).toFixed(2),
            };
          } else {
            const calculatedTotalWt = (parseFloat(b.oldWeight || 0) + currentWeight).toFixed(3);
            const calculatedTotalBal = (parseFloat(b.oldBalance || 0) + currentAmount).toFixed(2);
            extraData = {
              oldWeight: parseFloat(b.oldWeight || 0).toFixed(3),
              totalWeight: calculatedTotalWt,
              oldBalance: parseFloat(b.oldBalance || 0).toFixed(2),
              closingBalance: calculatedTotalBal,
            };
          }
        }
      } catch (err) {
        console.warn("Could not fetch customer balances for print:", err);
      }
    }

    const data = buildPrintData(rowIndex, extraData);
    const safeVoucherNo = (data.VoucherNo || String(slno)).replace(/[^a-zA-Z0-9_-]/g, "_");
    const safeDate = (data.Date || "").replace(/\//g, "-");
    const fileName = `SchemeReceipt_${safeVoucherNo}_${safeDate}.pdf`;

    // "print"    → looks up "SCHEME RECEIPT"      (your 58mm thermal design)
    // "download" → looks up "SCHEME RECEIPT PDF"  (your A4 full-invoice design)
    //              falls back to "SCHEME RECEIPT" if no PDF template assigned yet
    const voucherKey = action === "download" ? "SCHEME RECEIPT PDF" : "SCHEME RECEIPT";

    setIsPrintLoading(true);
    try {
      await printWithTemplate(voucherKey, data, apiBaseUrl, dbCode, {
        action,
        location: activeLocation?.id || 0,
        fileName,
      });
      if (action !== "blob") closePrintDialog();
    } catch (err) {
      // If the PDF template isn't assigned yet, fall back to the print template silently
      if (action === "download" && err?.message?.includes("No print template assigned")) {
        try {
          await printWithTemplate("SCHEME RECEIPT", data, apiBaseUrl, dbCode, {
            action,
            location: activeLocation?.id || 0,
            fileName,
          });
          closePrintDialog();
          return;
        } catch (_) {}
      }
      console.warn("Print template encountered an issue, falling back to classic print modal:", err);
      // Fallback: Open legacy Print modal so printing never fails for the user
      setPrintData({ tableData, schemeRecInfoData, index: slno });
      setShowPrintModel(true);
      closePrintDialog();
    } finally {
      setIsPrintLoading(false);
    }
  };

  // ////////////////////console.log("table data ===== ", tableData);

  const [locationOptions, setLocationOptions] = useState([]);

  const storedLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
  const storedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");

    const getDefaultBranch = () => {
    if (activeLocation?.id) return [Number(activeLocation.id), activeLocation.name];
    if (storedLocId) return [Number(storedLocId), storedLocName || "SHOP"];
    return [0, "SHOP"];
  };

  const getCleanLocationId = (locVal) => {
    if (Array.isArray(locVal)) {
      let inner = locVal[0];
      if (Array.isArray(inner)) inner = inner[0];
      const n = Number(inner);
      if (!isNaN(n) && n > 0) return n;
    } else if (locVal !== null && locVal !== undefined) {
      const n = Number(locVal);
      if (!isNaN(n) && n > 0) return n;
    }
    const fallback = Number(activeLocation?.id || storedLocId || 0);
    return fallback > 0 ? fallback : 1;
  };

  const resolveRecordLocation = (rawLoc) => {
    let locId = Array.isArray(rawLoc) ? rawLoc[0] : rawLoc;
    if (Array.isArray(locId)) locId = locId[0];
    const numId = Number(locId);
    if (!isNaN(numId) && numId > 0) {
      const found = locationOptions.find((item) => Number(item[0]) === numId);
      return found || [numId, "SHOP"];
    }
    return getDefaultBranch();
  };

  useEffect(() => {
    const fetchLocations = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`
        );
        const data = response.data || [];
        const filtered = data
          .filter((item) => String(item.Type || item.type || "").toLowerCase() === "location")
          .map((item) => [Number(item.Auto ?? item.auto ?? 0), item.Name || item.name]);
        setLocationOptions(filtered);

        if (filtered.length > 0) {
          const targetId = activeLocation?.id || storedLocId;
          const match = targetId ? filtered.find((l) => Number(l[0]) === Number(targetId)) : null;
          const chosen = match || filtered[0];
          setschemeRecInfoData((prev) => {
            if (!prev.Location || !prev.Location[0] || prev.Location[0] === 0) {
              return { ...prev, Location: chosen };
            }
            return prev;
          });
        }
      } catch (error) {
        console.error("Error fetching location options:", error);
      }
    };
    fetchLocations();
  }, [apiBaseUrl, dbCode, activeLocation]);

  const [schemeRecInfoData, setschemeRecInfoData] = useState({
    EntryNo: "",
    cashAcc: "",
    rate: "",
    date: (minDate && maxDate) ? (new Date() >= new Date(minDate) && new Date() <= new Date(maxDate) ? getCurrentDate() : minDate) : getCurrentDate(),
    salesMan: "",
    totalamt: 0,
    totalDisc: 0,
    totalamtdisc: 0,
    totalgm: 0,
    totaldiscgm: 0,
    totalTotalGm: 0,
    agCode: parseInt(agentCode),
    schemeId: "",
    Location: getDefaultBranch(),
  });
  ////////console.log("info data = ", schemeRecInfoData);

  ///////////////////////////////////////////////
  // const[accountTransaction,setAccountTransaction]=useState({
  // atDate:"",
  // atLedcode:"",
  // atType:"",
  // atEntryNo:"",
  // atAmount:"",
  // atNarration:"",

  //})

  ///////////////////////////////////////////////

  const handleCellChange = (event, rowIndex, field) => {
    setTableData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: event,
      };
      return newData;
    });
  };

  // const handleCellChangeinput = (event, rowIndex, field) => {

  //     const newData = [...tableData]; // Create a copy of the tableData array
  //     newData[rowIndex] = { ...newData[rowIndex], [field]: event.target.value }; // Update the value of the specified field in the row
  //     setTableData(newData); // Update the tableData state with the modified data

  // };
  const calculateGmvalue = (amount, index, field = "gm") => {
    if (!schemeRecInfoData.rate) {
      handleCellChange("", index, field);
      return;
    }

    if (amount !== "" && amount !== null && amount !== undefined) {
      const Rate = schemeRecInfoData.rate;
      if (Rate !== 0) {
        const calcgm = (amount / Rate).toFixed(roundOff);
        handleCellChange(calcgm, index, field);
      }
    } else {
      handleCellChange("", index, field);
    }
  };

  const calculateRowTotalAndGms = (index, currentTableData = null) => {
    setTableData((prevData) => {
      const baseData = currentTableData || prevData;
      const row = baseData[index] || {};
      const amt = parseFloat(row.amount || 0);
      const disc = parseFloat(row.disc || 0);
      const tot = amt + disc;

      const rate = parseFloat(schemeRecInfoData.rate || 0);
      let gmVal = "";
      let discGmVal = "";
      let totalGmVal = "";

      if (rate !== 0) {
        if (
          row.amount !== "" &&
          row.amount !== null &&
          row.amount !== undefined
        ) {
          gmVal = (amt / rate).toFixed(roundOff);
        }
        if (row.disc !== "" && row.disc !== null && row.disc !== undefined) {
          discGmVal = (disc / rate).toFixed(roundOff);
        }
        if (tot > 0 || row.amount !== "" || row.disc !== "") {
          totalGmVal = (tot / rate).toFixed(roundOff);
        }
      }

      const newData = [...baseData];
      newData[index] = {
        ...newData[index],
        total: tot > 0 || row.amount !== "" || row.disc !== "" ? tot : "",
        gm: gmVal,
        discGm: discGmVal,
        totalGm: totalGmVal,
      };
      return newData;
    });
  };

  const checkNameExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!cnameData.find((item) => item[1] === e.target.value)) {
        alert("account not registered");
      }
    }
  };

  const checkAccnoExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!accNo.find((item) => item[1] === e.target.value)) {
        alert("Account number not registered");
      }
    }
  };
  const checkledgerExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!selectcashAcc.find((item) => item[1] === e.target.value)) {
        alert("Account does not Exist");
      }
    }
  };

  const handleCellChangeinput = (event, rowIndex, field) => {
    const val =
      field === "printgm" ? (event.target.checked ? 1 : 0) : event.target.value;
    setTableData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: val,
        SINo: rowIndex + 1,
      };
      return newData;
    });
  };

  // Initial focus is handled dynamically by FormDesign Context Provider

  const handleKeyDown = (event, nextInputRefOrFieldId) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      if (typeof nextInputRefOrFieldId === "string") {
        handleDynamicKeyDown(event, nextInputRefOrFieldId);
      } else if (nextInputRefOrFieldId && nextInputRefOrFieldId.current) {
        nextInputRefOrFieldId.current.focus();
      }
    }
  };
  const [RowIndex, setRowIndex] = useState(0);
  // ////////////////////console.log(RowIndex);

  const handleKeyDownTable = (event, rowIndex, columnIndex) => {
    const visibleCols = gridColumns.filter((c) => c.show);
    const col = visibleCols[columnIndex];
    if (col) {
      handleDynamicKeyDown(event, `grid_${rowIndex}_${col.columnName}`);
    }
    setRowIndex(rowIndex);
  };

  /////////////////////////////////////////////

  useEffect(() => {
    const fetchSchEntryno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_entryno/${parseInt(formId)}/${dbCode}/${fyid}`,
        );
        // ////////////////////console.log("response =", response);
        const schemeRecentryNo = response.data.map((item) => item[""]);

        setschemeRecInfoData((prevData) => ({
          ...prevData,
          EntryNo: schemeRecentryNo[0],
        }));
        // setSchEntryNo(schemeentryNo[0] );
      } catch (error) {
        console.error("Error fetching entry no:", error.message);
      }
    };

    fetchSchEntryno();
  }, [apiBaseUrl, formId, fyid]);

  const fetchSchEntryno = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_entryno/${parseInt(formId)}/${dbCode}/${fyid}`,
      );
      // ////////////////////console.log("response =", response);
      const schemeRecentryNo = response.data.map((item) => item[""]);

      setschemeRecInfoData((prevData) => ({
        ...prevData,
        EntryNo: schemeRecentryNo[0],
      }));
      // setSchEntryNo(schemeentryNo[0] );
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  };

  useEffect(() => {
    // Connect to the WebSocket server
    const socket = io(apiBaseUrl); // Make sure the URL matches your backend server
    socket.on("tableUpdated", () => {
      fetchSchEntryno(); // Re-fetch the data when an update is detected
    });
    socket.on("printTemplateUpdated", () => {
      clearPrintTemplateCache();
    });
    socket.on("SchemeUpdated", () => {
      fetchSchemes();
    });

    const handleLocalPrintSync = () => {
      clearPrintTemplateCache();
    };
    window.addEventListener("printTemplateUpdated", handleLocalPrintSync);

    return () => {
      socket.disconnect(); // Clean up the socket connection on component unmount
      window.removeEventListener("printTemplateUpdated", handleLocalPrintSync);
    };
  }, [apiBaseUrl, formId, dbCode]);

  ///Scheme Name //////

  const [schemeNames, setschemeNames] = useState([]);
  // Stores full scheme info keyed by SchemeId for date validation
  const [schemeDateMap, setSchemeDateMap] = useState({});

  const fetchSchemes = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getSchemes/${dbCode}`,
      );

      if (response.data.success) {
        //console.log("Schemes fetched:", response.data.data);

        // Format for ComboBox: array of [value, label] pairs
        const formattedSchemes = response.data.data.map((item) => [
          item.SchemeId,
          item.SchemeName,
        ]);

        // Build a map of SchemeId -> { fromDate, toDate, validityType, schemeType } for validation
        const dateMap = {};
        response.data.data.forEach((item) => {
          dateMap[item.SchemeId] = {
            fromDate: item.FromDate ? item.FromDate.substring(0, 10) : null,
            toDate: item.ToDate ? item.ToDate.substring(0, 10) : null,
            validityType: item.ValidityType || "Fixed",
            schemeType: item.SchemeType || "Monthly",
          };
        });
        setSchemeDateMap(dateMap);
        setschemeNames(formattedSchemes);

        // Keep current selected scheme name synchronized if it was updated
        setschemeRecInfoData((prev) => {
          if (Array.isArray(prev.schemeId) && prev.schemeId.length > 0) {
            const currentId = prev.schemeId[0];
            const updated = response.data.data.find(
              (item) => item.SchemeId === currentId,
            );
            if (updated && updated.SchemeName !== prev.schemeId[1]) {
              return {
                ...prev,
                schemeId: [updated.SchemeId, updated.SchemeName],
              };
            }
          }
          return prev;
        });
      }
    } catch (error) {
      console.error("Error fetching schemes:", error);
    }
  };

  useEffect(() => {
    fetchSchemes();
  }, [apiBaseUrl]);

  /////customer name //////

  const [cnameData, setCnameData] = useState([]);

  useEffect(() => {
    const fetchCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_Cname/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const cName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = cName.map((item) => [
          item.Ledcode,
          item.LedName,
        ]);
        setCnameData(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching cashorsuppl Values:", error.message);
      }
    };

    fetchCname();
  }, [apiBaseUrl]);

  // ////////////////////console.log('cnameData=', cnameData);

  // useEffect(() => {
  //   const fetchCname = async () => {
  //     try {
  //       const response = await axios.get(`${apiBaseUrl}/main/SchRec_Cname`);
  //       setCnameData(response.data);

  //       // ////////////////////console.log("11111", response.data);
  //     } catch (error) {
  //       console.error("Error fetching cname data:", error.message);
  //     }
  //   };

  //   fetchCname();
  // }, [apiBaseUrl]);

  //////////agent name///////////////

  const [agentName, setagentName] = useState([]);
  const [agentobj, setAgentObj] = useState([]);

  useEffect(() => {
    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const AgName = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    fetchAgname();
  }, [apiBaseUrl]);

  const [Billers, setbillers] = useState([]);

  useEffect(() => {
    const fetchbillers = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectAllbillers/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const billers = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = billers.map((item) => [item.Auto, item.Name]);
        setbillers(transformedData);

        // setsupplierName(supplName);
      } catch (error) {
        console.error("Error fetching billers Values:", error.message);
      }
    };

    fetchbillers();
  }, [apiBaseUrl]);

  //////acc no////////////

  const [accNo, setaccNo] = useState([]);
  const [filteredaccNo, setfilteredaccNo] = useState([]);

  const [schemedatas, setschemedatas] = useState([]);

  //console.log('......',accNo);

  // useEffect(() => {
  //   const fetchAccno = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`
  //       );

  //       // Assuming response.data is an array with objects and each object has a LedName property
  //       const Accno = response.data;

  //       // Transforming the array into the desired format
  //       // const supplName = cName.map((item) => item.LedName);

  //       const transformedData = Accno.map((item) => [item.auto, item.accno]);
  //       setaccNo(transformedData);

  //       // setsupplierName(supplName);
  //     } catch (error) {
  //       console.error("Error fetching accno Values:", error.message);
  //     }
  //   };

  //   fetchAccno();
  // }, [apiBaseUrl]);
  const storeduType = sessionStorage.getItem("userType");

  useEffect(() => {
    const fetchAccno = async () => {
      try {
        // Check if agent-wise account number is enabled in settings

        const agentWiseSetting = GeneralSettings.find(
          (item) => item.Name === "AGENT WISE ACCOUNT NUMBER IN SCHEME RECEIPT",
        );

        const useAgentWise =
          agentWiseSetting && agentWiseSetting.ss_status === 1;
        ////console.log("useAgentWise==", useAgentWise);

        let url;

        if (useAgentWise && storeduType !== "ADMIN") {
          // Use agent-wise API for non-admin users when setting is enabled
          url = `${apiBaseUrl}/main/SchRec_AccnobyAgent/${parseInt(
            agentCode,
          )}/${dbCode}`;
        } else {
          // Use general API for admin users OR when setting is disabled
          url = `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`;
        }

        const response = await axios.get(url);
        console.log("Fetched accno data:", response.data);
        //  response.data is an array with objects and each object has a LedName property
        setschemedatas(response.data);

        // Transforming the array into the desired format

        const transformedData = response.data.map((item) => [
          item.auto,
          item.accno,
        ]);

        setaccNo(transformedData);
      } catch (error) {
        console.error("Error fetching accno Values:", error.message);
      }
    };

    fetchAccno();
  }, [apiBaseUrl, storeduType, agentCode, GeneralSettings, dbCode]);

  // Create a function to filter account numbers by scheme
  const filterAccountNumbersByScheme = (selectedScheme) => {
    if (!selectedScheme || !Array.isArray(selectedScheme)) {
      setfilteredaccNo([]);
      return;
    }
    const schemeId = selectedScheme[0];

    const filteredData = schemedatas.filter(
      (item) => item.schemeId === schemeId && item.isActive === true,
    );

    const transformedData = filteredData.map((item) => [item.auto, item.accno]);
    setfilteredaccNo(transformedData);
  };

  const handleSchemeChange = (newScheme) => {
    const newSchemeId = Array.isArray(newScheme) ? newScheme[0] : null;
    const currentSchemeId = Array.isArray(schemeRecInfoData.schemeId)
      ? schemeRecInfoData.schemeId[0]
      : null;

    const hasData = tableData.some(
      (row) =>
        (row.accountNumber && (Array.isArray(row.accountNumber) ? row.accountNumber[1] : row.accountNumber)) ||
        (row.name && (Array.isArray(row.name) ? row.name[1] : row.name)) ||
        (row.amount && row.amount !== "")
    );

    if (hasData && newSchemeId && currentSchemeId && newSchemeId !== currentSchemeId) {
      const confirmClear = window.confirm(
        "Changing Scheme will clear the customer entries entered in the table.\nDo you want to proceed?"
      );
      if (!confirmClear) {
        return;
      }
      setTableData(createEmptyRows(14));
    }

    setschemeRecInfoData((prev) => ({ ...prev, schemeId: newScheme }));
    filterAccountNumbersByScheme(newScheme);
  };
  const [selectcashAcc, setselectcashAcc] = useState([]);
  // ////////////////////console.log("selectcashAcc", selectcashAcc);

  useEffect(() => {
    const selectcashAcc = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
        );

        // Assuming response.data is an array with objects and each object has a LedName property
        const caba = response.data;

        // Transforming the array into the desired format
        // const supplName = cName.map((item) => item.LedName);

        const transformedData = caba.map((item) => [
          item.ledcode,
          item.LedName,
        ]);
        setselectcashAcc(transformedData);

        const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
        const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
        if (effectiveUType !== "CUSTOMERS" && effectiveAg) {
          fetchcashAcc(transformedData, effectiveAg);
        }
      } catch (error) {
        console.error("Error fetching selectcashAcc Values:", error.message);
      }
    };
    selectcashAcc();
  }, [apiBaseUrl, userType, dbCode, agentCode]);

  const Selectcashacc = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
      );

      const caba = response.data;
      const transformedData = caba.map((item) => [item.ledcode, item.LedName]);
      setselectcashAcc(transformedData);

      const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
      const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
      if (effectiveUType !== "CUSTOMERS" && effectiveAg) {
        fetchcashAcc(transformedData, effectiveAg);
      }
    } catch (error) {
      console.error("Error fetching selectcashAcc Values:", error.message);
    }
  };

  useEffect(() => {
    const socket = io(apiBaseUrl);
    socket.on("LedgerUpdated", () => {
      Selectcashacc();
    });
    socket.on("dataUpdated", () => {
      Selectcashacc();
    });
    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode, userType]);

  const fetchcashAcc = async (data = selectcashAcc, targetAgentCode = null) => {
    const rawAgent = targetAgentCode || schemeRecInfoData.salesMan?.[0] || agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
    const activeAgCode = parseInt(rawAgent, 10);
    if (!activeAgCode || isNaN(activeAgCode) || !dbCode) {
      return;
    }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/fetchcashacc/${activeAgCode}/${dbCode}`,
      );
      const caba = response.data?.[0];
      if (caba && caba.cashAcc) {
        const targetAccId = parseInt(caba.cashAcc, 10);
        const accList = (data && data.length > 0) ? data : selectcashAcc;
        const matchedAcc = accList.find((item) => parseInt(item[0], 10) === targetAccId);
        if (matchedAcc) {
          setschemeRecInfoData((prevState) => ({
            ...prevState,
            cashAcc: matchedAcc,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching Accno data:", error.message);
    }
  };

  useEffect(() => {
    const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
    const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
    if (effectiveUType !== "CUSTOMERS" && effectiveAg && selectcashAcc.length > 0) {
      if (!schemeRecInfoData.cashAcc || (Array.isArray(schemeRecInfoData.cashAcc) && !schemeRecInfoData.cashAcc[0])) {
        fetchcashAcc(selectcashAcc, effectiveAg);
      }
    }
  }, [agentCode, selectcashAcc, dbCode]);

  // fetchcashAcc()

  // }, [apiBaseUrl,agentCode]);

  const fetchSchCurrentRate = async (targetDate) => {
    try {
      const dateToUse = targetDate || schemeRecInfoData.date;
      const response = await axios.get(
        `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${dateToUse || ""}`
      );
      const currentrate = response.data[0]?.currentRate;
      setschemeRecInfoData((prevData) => ({
        ...prevData,
        rate: userRights && userRights.GR === 1 ? (currentrate || 0) : 0,
      }));
    } catch (error) {
      console.error("Error fetching gold rate:", error.message);
    }
  };

  useEffect(() => {
    fetchSchCurrentRate(schemeRecInfoData.date);
  }, [apiBaseUrl, userRights, dbCode, schemeRecInfoData.date]);

  ////////////////total calculations/////////////////////////////

  useEffect(() => {
    let totalAmount = 0;
    let totalDisc = 0;
    let totalAmtDisc = 0;
    let totalGm = 0;
    let totalDiscGm = 0;
    let totalTotalGm = 0;
    tableData.forEach((rowData) => {
      totalAmount += parseFloat(rowData.amount || 0);
      totalDisc += parseFloat(rowData.disc || 0);
      totalAmtDisc += parseFloat(rowData.total || 0);
      totalGm += parseFloat(rowData.gm || 0);
      totalDiscGm += parseFloat(rowData.discGm || 0);
      totalTotalGm += parseFloat(rowData.totalGm || 0);
    });
    setschemeRecInfoData((prevState) => ({
      ...prevState,
      totalamt: totalAmount.toFixed(roundOff),
      totalDisc: totalDisc.toFixed(roundOff),
      totalamtdisc: totalAmtDisc.toFixed(roundOff),
      totalgm: totalGm.toFixed(roundOff),
      totaldiscgm: totalDiscGm.toFixed(roundOff),
      totalTotalGm: totalTotalGm.toFixed(roundOff),
    }));
  }, [tableData, roundOff]);

  ////////////////////

  const [comboValue, setComboValue] = useState("");
  const handleClearCombo = () => {
    setComboValue("");
  };
  ///////////////////////////////////clear/////////////////////////////

  const handleClear = () => {
    fetchSchEntryno();
    fetchSchCurrentRate();
    Selectcashacc();
    setdispWt("");
    setdispTm("");
    setschemeRecInfoData({
      cashAcc: "",
      schemeId: "",
      salesMan: "",
      date: getCurrentDate(),
      totalamt: "",
      totalDisc: "",
      totalamtdisc: "",
      totalgm: "",
      totaldiscgm: "",
      Location: getDefaultBranch(),
    });

    setTableData(createEmptyRows(14));

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setShowverifyPassword(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };

  const handleClearfind = () => {
    // fetchSchEntryno();
    // fetchSchCurrentRate();
    // setschemeRecInfoData({
    //   cashAcc: "",

    //   date: getCurrentDate(),
    //   totalamt: "",
    //   totalgm: "",
    // });

    setTableData(createEmptyRows(14));

    triggerInitialFocus();
    setRowIndex(0);
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setShowverifyPassword(false);

    // const [editDisabled, setEditDisabled] = useState(true);
    // const [deleteDisabled, setDeleteDisabled] = useState(true);
    // const [saveDisabled, setSaveDisabled] = useState(false);
  };
  ////////////////////////////////////////////////////////

  const fetchsmssettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectapidatas/${dbCode}/${eName}?locationId=${activeLocation ? activeLocation.id : ""}`,
      );

      const smsData = response.data[0];
      ////////////////console.log("smsData=", smsData);

      return smsData;
    } catch (error) {
      console.error("Error fetching smssettings Values:", error.message);
    }
  };
  const fetchwhatsappsettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/${eName}?locationId=${activeLocation ? activeLocation.id : ""}`,
      );

      const whtsappData = response.data[0];
      ////console.log("whtasdata=", whtsappData);

      return whtsappData;
    } catch (error) {
      console.error("Error fetching whtsappData Values:", error.message);
    }
  };

  const sendWhatsAppMessage = async (
    accountNo,
    mobileNo,
    customerName,
    total,
    grandTotal,
    netwt,
    gm,
  ) => {
    try {
      if (genValues?.sendwhatsappmsg !== 1) {
        return { success: false, message: "WhatsApp messaging disabled" };
      }

      const whatsappData = await fetchwhatsappsettings("SCHEME RECEIPT");

      if (!whatsappData) {
        console.error("WhatsApp settings not found");
        return { success: false, message: "WhatsApp settings not found" };
      }

      const formattedTotal = formatSmsAmount(total);
      const formattedGrandTotal = formatSmsAmount(grandTotal);
      const formattedNetwt = formatSmsWeight(netwt);
      const formattedGm = formatSmsWeight(gm);
      const formattedRate = formatSmsAmount(schemeRecInfoData.rate);
      const showroomName = (Array.isArray(schemeRecInfoData.Location) ? schemeRecInfoData.Location[1] : schemeRecInfoData.Location) || sessionStorage.getItem("loginLocation") || "";

      let message = whatsappData.MessageBody || "";

      const replacements = {
        "${accountNo}": accountNo ?? "",
        "${customerName}": customerName ?? "",
        "${total}": formattedTotal,
        "${grandTotal}": formattedGrandTotal,
        "${netwt}": formattedNetwt,
        "${gm}": formattedGm,
        "${rate}": formattedRate,
        "${showroomName}": showroomName,
        "${date}": schemeRecInfoData.date || new Date().toLocaleDateString(),
        "${entryNo}": schemeRecInfoData.EntryNo || "",
      };

      Object.keys(replacements).forEach((key) => {
        message = message.split(key).join(replacements[key]);
      });

      const messageData = new FormData();
      messageData.append("appkey", whatsappData.appKey || "");
      messageData.append("authkey", whatsappData.Authkey || "");
      messageData.append("to", `91${mobileNo}`);
      messageData.append("message", message);

      if (whatsappData.MediaUrl) {
        messageData.append("file", whatsappData.MediaUrl);
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      const response = await axios.post(
        "https://wabulksenderpro.net/api/create-message",
        messageData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          signal: controller.signal,
        },
      );

      clearTimeout(timeoutId);

      return {
        success: true,
        data: response.data,
        message: `Message sent to ${mobileNo}`,
      };
    } catch (error) {
      console.error(`Error sending WhatsApp message to ${mobileNo}:`, {
        message: error.message,
        code: error.code,
        response: error.response?.data,
        status: error.response?.status,
        isAxiosError: axios.isAxiosError(error),
        isTimeout: error.code === "ECONNABORTED" || error.name === "AbortError",
      });

      return {
        success: false,
        error: error.message,
        mobileNo: mobileNo,
      };
    }
  };

  const sendSMS = async (
    accountNo,
    mobileNo,
    customerName,
    total,
    grandTotal,
    netwt,
    gm,
  ) => {
    if (userRights?.SRSMS !== 1) {
      return;
    }

    const apiData = await fetchsmssettings("SCHEME RECEIPT");
    if (!apiData || !apiData.MessageBody || !apiData.ApiLink) {
      console.warn("SMS settings not found or incomplete for SCHEME RECEIPT");
      return null;
    }

    const formattedTotal = formatSmsAmount(total);
    const formattedGrandTotal = formatSmsAmount(grandTotal);
    const formattedNetwt = formatSmsWeight(netwt);
    const formattedGm = formatSmsWeight(gm);
    const formattedRate = formatSmsAmount(schemeRecInfoData.rate);
    const showroomName = (Array.isArray(schemeRecInfoData.Location) ? schemeRecInfoData.Location[1] : schemeRecInfoData.Location) || sessionStorage.getItem("loginLocation") || "";

    let message = apiData.MessageBody || "";

    const replacements = {
      "${accountNo}": accountNo ?? "",
      "${customerName}": customerName ?? "",
      "${total}": formattedTotal,
      "${grandTotal}": formattedGrandTotal,
      "${netwt}": formattedNetwt,
      "${gm}": formattedGm,
      "${rate}": formattedRate,
      "${showroomName}": showroomName,
      "${date}": schemeRecInfoData.date || new Date().toLocaleDateString(),
      "${entryNo}": schemeRecInfoData.EntryNo || "",
    };

    Object.keys(replacements).forEach((key) => {
      message = message.split(key).join(replacements[key]);
    });

    const url = apiData.ApiLink
      .split("${mobileNo}").join(mobileNo)
      .split("${encodeURIComponent(message)}").join(encodeURIComponent(message))
      .split("${message}").join(encodeURIComponent(message));

    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error sending SMS to ${mobileNo}:`, error.message);
      return null;
    }
  };

  const handleSave = async () => {
    setSaveDisabled(true);

    try {
      if (schemeRecInfoData.date && !isDateInFy(schemeRecInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        return;
      }
      // VALIDATION for schemeId
      if (!Array.isArray(schemeRecInfoData.schemeId)) {
        alert("Select Scheme Name.");
        setSaveDisabled(false);
        return;
      }

      // ── Scheme date range validation ──
      const selectedSchemeId = schemeRecInfoData.schemeId?.[0];
      const schemeInfo = schemeDateMap[selectedSchemeId];
      if (schemeInfo) {
        const receiptDate = schemeRecInfoData.date; // "YYYY-MM-DD"
        // Only block scheme header if Fixed scheme has an expired toDate
        if (schemeInfo.validityType === "Fixed" && schemeInfo.toDate && receiptDate > schemeInfo.toDate) {
          alert(
            `The scheme "${schemeRecInfoData.schemeId?.[1]}" has expired on ${schemeInfo.toDate}.\nReceipts cannot be saved after the scheme end date.`
          );
          setSaveDisabled(false);
          return;
        }
        if (schemeInfo.fromDate && receiptDate < schemeInfo.fromDate) {
          alert(
            `Receipt date (${receiptDate}) is before the scheme "${schemeRecInfoData.schemeId?.[1]}" start date (${schemeInfo.fromDate}).\nReceipts must be within the scheme period.`
          );
          setSaveDisabled(false);
          return;
        }
      }

      if (!schemeRecInfoData.cashAcc) {
        // If cashAcc is not filled, display an alert and return without saving
        alert("Enter Data  Correctly.");
        setSaveDisabled(false);

        return;
      } else if (schemeRecInfoData.salesMan.length > 0) {
        if (!Array.isArray(schemeRecInfoData.salesMan)) {
          alert("Enter Data Correctly.");
          setSaveDisabled(false);
          return;
        }
      }

      const hasData = tableData.some((row) => {
        return (
          row.name &&
          row.agent &&
          row.accountNumber &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        alert("Enter Data  Correctly.");
        setSaveDisabled(false);

        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      // ── Row-level Scheme & Account Validation ──
      for (let i = 0; i < filteredTableData.length; i++) {
        const row = filteredTableData[i];
        if (!row.accountNumber) continue;

        const accNoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[1]
          : row.accountNumber;
        const accAutoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[0]
          : null;

        const matchedAcc = schemedatas.find(
          (item) =>
            (accAutoVal && item.auto === accAutoVal) || item.accno === accNoVal
        );

        const rowSchemeId = matchedAcc?.schemeId || row.schemeId;

        if (rowSchemeId && rowSchemeId !== selectedSchemeId) {
          const actualScheme = schemeNames.find((s) => s[0] === rowSchemeId);
          const actualSchemeName = actualScheme ? actualScheme[1] : `Scheme ID ${rowSchemeId}`;
          const currentSchemeName = schemeRecInfoData.schemeId?.[1] || "Selected Scheme";

          alert(
            `Account "${accNoVal}" belongs to scheme "${actualSchemeName}", not "${currentSchemeName}".\nReceipts can only contain accounts belonging to the selected scheme.`
          );
          setSaveDisabled(false);
          return;
        }

        if (rowSchemeId) {
          const accSchemeInfo = schemeDateMap[rowSchemeId];
          const receiptDate = schemeRecInfoData.date;

          // Account-level ExpiryDate check (applies to both Fixed and Tenure schemes)
          let accountExpiryDate = matchedAcc?.ExpiryDate ? String(matchedAcc.ExpiryDate).substring(0, 10) : null;
          if (!accountExpiryDate && accSchemeInfo?.validityType === "Tenure" && matchedAcc?.Date && matchedAcc?.duration) {
            const d = new Date(matchedAcc.Date);
            if (accSchemeInfo?.schemeType === "Daily") {
              d.setDate(d.getDate() + Number(matchedAcc.duration));
            } else {
              d.setMonth(d.getMonth() + Number(matchedAcc.duration));
            }
            accountExpiryDate = d.toISOString().substring(0, 10);
          } else if (!accountExpiryDate && accSchemeInfo?.toDate) {
            accountExpiryDate = accSchemeInfo.toDate;
          }

          if (accountExpiryDate && receiptDate > accountExpiryDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accountExpiryDate}.\nReceipts cannot be saved after the scheme end date.`
            );
            setSaveDisabled(false);
            return;
          }

          if (accSchemeInfo?.validityType === "Fixed" && accSchemeInfo?.toDate && receiptDate > accSchemeInfo.toDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accSchemeInfo.toDate}.\nReceipts cannot be saved after the scheme end date.`
            );
            setSaveDisabled(false);
            return;
          }

          if (accSchemeInfo?.fromDate && receiptDate < accSchemeInfo.fromDate) {
            alert(
              `Receipt date (${receiptDate}) is before the start date (${accSchemeInfo.fromDate}) for account "${accNoVal}".`
            );
            setSaveDisabled(false);
            return;
          }
        }
      }

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        name: row.name?.[0] || null, // Access the second item of the name array
        agent: row.agent?.[0] || null, // Access the second item of the agent array
        accountNumber: row.accountNumber?.[0] || null, // Access the second item of the accountNumber array
        amount: row.amount || null,
        discount: row.disc || 0,
        total: row.total || row.amount || null,
        gm: row.gm || null,
        discGm: row.discGm || 0,
        totalGm: row.totalGm || row.gm || null,
        narration: row.narration || null,
        printgm: row.printgm || null,
        billed: row.billed || 0,
        schemeId: selectedSchemeId,
      }));
      // ////////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(
        `${apiBaseUrl}/main/saveSchRec/${dbCode}`,
        {
          statementType: "SchRec_insert",
          cashacc: schemeRecInfoData.cashAcc?.[0],
          schemeId: schemeRecInfoData.schemeId?.[0],
          rate: Number(schemeRecInfoData.rate) || 0,
          date: schemeRecInfoData.date,
          salesMan: schemeRecInfoData.salesMan?.[0] || 0,
          totalamount: schemeRecInfoData.totalamt,
          totalDisc: schemeRecInfoData.totalDisc,
          totalamtdisc: schemeRecInfoData.totalamtdisc,
          totalgm: schemeRecInfoData.totalgm,
          totaldiscgm: schemeRecInfoData.totaldiscgm,
          agCode: Number(agentCode || 0),
          formId: Number(frmId || formId || 0),
          fyid: Number(fyid || activeFyid || 0),
          Location: getCleanLocationId(schemeRecInfoData.Location),

          type: transformedTableData,
        },
      );

      if (response.data.success) {
        const accountNumbers = transformedTableData.map(
          (row) => row.accountNumber,
        );
        const mobileNumbersResponse = await axios.post(
          `${apiBaseUrl}/main/fetchMobileNos/${dbCode}`,
          {
            accountNumbers,
          },
        );

        if (mobileNumbersResponse.data) {
          // ////////////////////console.log("Mobile Numbers:", mobileNumbersResponse.data);

          // Send SMS to each mobile number
          mobileNumbersResponse.data.forEach(async (mobileNumber) => {
            // ////////////////////console.log(transformedTableData);
            // ////////////////////console.log(mobileNumber);
            const customerData = transformedTableData.find(
              (row) => row.name === mobileNumber.accname,
            );
            // ////////////////////console.log("customerData==", customerData);

            if (customerData) {
              const total = formatSmsAmount(customerData.total || customerData.amount);
              const netwt = formatSmsWeight(mobileNumber.totalWt);
              const grandTotal = formatSmsAmount(mobileNumber.totalAmt);
              const gm = formatSmsWeight(customerData.totalGm || customerData.gm);
              const matchedAccNo = accNo.find((item) => item[0] === customerData.accountNumber)?.[1] || customerData.accountNumber;
              const matchedCustName = cnameData.find((item) => item[0] === mobileNumber.accname)?.[1] || "";

              const smsResponse = await sendSMS(
                matchedAccNo,
                mobileNumber.mobileNo,
                matchedCustName,
                total,
                grandTotal,
                netwt,
                gm,
              );

              // Send WhatsApp message if enabled in settings
              const whatsappResponse = await sendWhatsAppMessage(
                matchedAccNo,
                mobileNumber.mobileNo,
                matchedCustName,
                total,
                grandTotal,
                netwt,
                gm,
              );
              //console.log(`WhatsApp sent to ${mobileNumber.mobileNo}:`, whatsappResponse);
            }
          });
        }

        handleClear();
        //  Swal.fire("Success", "Data saved successfully!", "success");
        alert("Entry Saved");
        // Optionally, you can perform additional actions after successful save
      } else {
        // Swal.fire("Error", "Failed to save data!", "error");
        alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      //  Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
      setSaveDisabled(false);
    }
    handleClear();
  };

  const handleVerifyPassword = () => {
    setShowverifyPassword(true);
    //////////console.log("Verify Password clicked");
    //////////console.log("Verify Password ", verifyPassword);
  };

  const handleEdit = async (value) => {
    if (!value) {
      return;
    }

    // ADD THIS VALIDATION for schemeId
    if (!Array.isArray(schemeRecInfoData.schemeId)) {
      alert("Select Scheme Name.");
      setSaveDisabled(false);
      return;
    }

    // ── Scheme date range validation ──
    const selectedSchemeId = schemeRecInfoData.schemeId?.[0];
    const schemeInfo = schemeDateMap[selectedSchemeId];
    if (schemeInfo) {
      const receiptDate = schemeRecInfoData.date; // "YYYY-MM-DD"
      if (schemeInfo.validityType === "Fixed" && schemeInfo.toDate && receiptDate > schemeInfo.toDate) {
        alert(
          `The scheme "${schemeRecInfoData.schemeId?.[1]}" has expired on ${schemeInfo.toDate}.\nReceipts cannot be edited after the scheme end date.`
        );
        return;
      }
      if (schemeInfo.fromDate && receiptDate < schemeInfo.fromDate) {
        alert(
          `Receipt date (${receiptDate}) is before the scheme "${schemeRecInfoData.schemeId?.[1]}" start date (${schemeInfo.fromDate}).\nReceipts must be within the scheme period.`
        );
        return;
      }
    }

    try {
      // Check for billed rows first
      const billedRowsIndices = tableData
        .map((row, index) =>
          row.billed && row.billed !== 0 ? index + 1 : null,
        ) // +1 to make it 1-based index
        .filter((index) => index !== null);

      if (billedRowsIndices.length > 0 && parseInt(userRights?.SRSMS) === 0) {
        const indicesStr = billedRowsIndices.join(", ");
        alert(`Row(s): ${indicesStr} are already transferred. Cannot Edit.`);
        return;
      }

      if (!schemeRecInfoData.cashAcc) {
        // If cashAcc is not filled, display an alert and return without saving
        alert("Enter Data  Correctly.");
        return;
      }

      const hasData = tableData.some((row) => {
        return (
          row.name &&
          row.agent &&
          row.accountNumber &&
          row.amount &&
          Object.values(row).some((value) => value !== "")
        );
      });

      if (!hasData) {
        // If no data is entered, display an alert and return without saving
        alert("Enter Data  Correctly.");
        return;
      } else if (
        schemeRecInfoData.salesMan &&
        !Array.isArray(schemeRecInfoData.salesMan)
      ) {
        alert("Enter Data Correctly.");
        setSaveDisabled(false);
        return;
      }

      const filteredTableData = tableData.filter((row) => {
        // Check if any of the fields in the row is not empty
        return Object.values(row).some((value) => value !== "");
      });

      // ── Row-level Scheme & Account Validation ──
      for (let i = 0; i < filteredTableData.length; i++) {
        const row = filteredTableData[i];
        if (!row.accountNumber) continue;

        const accNoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[1]
          : row.accountNumber;
        const accAutoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[0]
          : null;

        const matchedAcc = schemedatas.find(
          (item) =>
            (accAutoVal && item.auto === accAutoVal) || item.accno === accNoVal
        );

        const rowSchemeId = matchedAcc?.schemeId || row.schemeId;

        if (rowSchemeId && rowSchemeId !== selectedSchemeId) {
          const actualScheme = schemeNames.find((s) => s[0] === rowSchemeId);
          const actualSchemeName = actualScheme ? actualScheme[1] : `Scheme ID ${rowSchemeId}`;
          const currentSchemeName = schemeRecInfoData.schemeId?.[1] || "Selected Scheme";

          alert(
            `Account "${accNoVal}" belongs to scheme "${actualSchemeName}", not "${currentSchemeName}".\nReceipts can only contain accounts belonging to the selected scheme.`
          );
          return;
        }

        if (rowSchemeId) {
          const accSchemeInfo = schemeDateMap[rowSchemeId];
          const receiptDate = schemeRecInfoData.date;

          let accountExpiryDate = matchedAcc?.ExpiryDate ? String(matchedAcc.ExpiryDate).substring(0, 10) : null;
          if (!accountExpiryDate && accSchemeInfo?.validityType === "Tenure" && matchedAcc?.Date && matchedAcc?.duration) {
            const d = new Date(matchedAcc.Date);
            if (accSchemeInfo?.schemeType === "Daily") {
              d.setDate(d.getDate() + Number(matchedAcc.duration));
            } else {
              d.setMonth(d.getMonth() + Number(matchedAcc.duration));
            }
            accountExpiryDate = d.toISOString().substring(0, 10);
          } else if (!accountExpiryDate && accSchemeInfo?.toDate) {
            accountExpiryDate = accSchemeInfo.toDate;
          }

          if (accountExpiryDate && receiptDate > accountExpiryDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accountExpiryDate}.\nReceipts cannot be edited after the scheme end date.`
            );
            return;
          }

          if (accSchemeInfo?.validityType === "Fixed" && accSchemeInfo?.toDate && receiptDate > accSchemeInfo.toDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accSchemeInfo.toDate}.\nReceipts cannot be edited after the scheme end date.`
            );
            return;
          }

          if (accSchemeInfo?.fromDate && receiptDate < accSchemeInfo.fromDate) {
            alert(
              `Receipt date (${receiptDate}) is before the start date (${accSchemeInfo.fromDate}) for account "${accNoVal}".`
            );
            return;
          }
        }
      }

      const transformedTableData = filteredTableData.map((row) => ({
        SINo: row.SINo || null,
        name: row.name[0] || null,
        agent: row.agent[0] || null,
        accountNumber: row.accountNumber[0] || null,
        amount: row.amount || null,
        discount: row.disc || 0,
        total: row.total || row.amount || null,
        gm: row.gm || null,
        discGm: row.discGm || 0,
        totalGm: row.totalGm || row.gm || null,
        narration: row.narration || null,
        printgm: row.printgm || null,
        billed: row.billed || 0,
        schemeId: selectedSchemeId,
      }));
      //////////////////////console.log("transformedTableData", transformedTableData);
      const response = await axios.post(
        `${apiBaseUrl}/main/updateSchRec/${dbCode}`,
        {
          statementType: "SchRec_edit",
          cashacc: schemeRecInfoData.cashAcc[0],
          schemeId: schemeRecInfoData.schemeId[0],
          rate: Number(schemeRecInfoData.rate) || 0,
          date: schemeRecInfoData.date,
          salesMan: schemeRecInfoData.salesMan?.[0] || 0,
          totalamount: schemeRecInfoData.totalamt,
          totalDisc: schemeRecInfoData.totalDisc,
          totalamtdisc: schemeRecInfoData.totalamtdisc,
          totalgm: schemeRecInfoData.totalgm,
          totaldiscgm: schemeRecInfoData.totaldiscgm,
          agCode: Number(agentCode || 0),
          formId: Number(frmId || formId || 0),
          fyid: Number(fyid || activeFyid || 0),
          Location: getCleanLocationId(schemeRecInfoData.Location),

          EntryNo: schemeRecInfoData.EntryNo,
          type: transformedTableData,
        },
      );

      if (response.data.success) {
        const accountNumbers = transformedTableData.map(
          (row) => row.accountNumber,
        );
        const mobileNumbersResponse = await axios.post(
          `${apiBaseUrl}/main/fetchMobileNos/${dbCode}`,
          {
            accountNumbers,
          },
        );

        if (mobileNumbersResponse.data) {
          // ////////////////////console.log("Mobile Numbers:", mobileNumbersResponse.data);

          // Send SMS to each mobile number
          mobileNumbersResponse.data.forEach(async (mobileNumber) => {
            const customerData = transformedTableData.find(
              (row) => row.accountNumber[0] === mobileNumber.accountNumber,
            );

            if (customerData) {
              const grandTotal = customerData.total || customerData.amount;
              const netwt = mobileNumber.totalWt;
              const total = mobileNumber.totalAmt;
              const gm = customerData.totalGm || customerData.gm;
              // const smsResponse = await sendSMS(
              //   accNo.find((item) => item[0] === customerData.accountNumber),
              //   mobileNumber.mobileNo,
              //   cnameData.find((item) => item[0] === mobileNumber.accname),
              //   grandTotal,
              //   total,
              //   netwt,
              //   gm
              // );

              // ////////////////////console.log(`SMS sent to ${mobileNumber.mobileNo}:`, smsResponse);
            }
          });
        }
        //   handleClear();
        // Swal.fire("Success", "Data Edit successfully!", "success");
        alert("Entry Edited");
        // Optionally, you can perform additional actions after successful save
        triggerInitialFocus();
      } else {
        // Swal.fire("Error", "Failed to edit data!", "error");
        alert("Failed to edit data!");
      }
    } catch (error) {
      console.error("Error edit data:", error.message);
      // Swal.fire("Error", "Internal server error!", "error");
      alert("Internal server error!");
    }
    // handleClear();
  };

  const getDisplayValue = (value) => {
    if (Array.isArray(value) && value.length > 0) {
      return value[0];
    }
    return "";
  };

  //////////////////////console.log("datra",tableData[0].accountNumber);

  const [accNoData, setAccNoData] = useState([]);
  // ////////////////////console.log("accNoData===", accNoData);
  // const fetchAccNoData = async (e, rowIndex, agCode) => {
  //   try {
  //     const response = await axios.get(
  //       `${apiBaseUrl}/main/findbyaccnotable/${e[1]}`
  //     );
  //     const fetchedData = response.data;
  //     const newData = [...tableData];

  //     // Check if fetched data exists and is in the correct format
  //     if (Array.isArray(fetchedData) && fetchedData.length > 0) {
  //       const { accname, agent } = fetchedData[0]; // Assuming only one record is fetched

  //       // Find the corresponding array in cnameData based on accname
  //       const matchingCnameData = cnameData.find((item) => item[0] === accname);

  //       // Find the corresponding array in agentName based on agent
  //       const matchingAgentData = agentName.find(
  //         (item) => item[0] === parseInt(agentCode)
  //       );

  //       // Update the name and agent fields of the current row in tableData
  //       if (rowIndex > 0 && rowIndex % 2 === 0) {
  //         newData[rowIndex - rowIndex / 2] = {
  //           ...newData[rowIndex - rowIndex / 2],
  //           name: matchingCnameData || [], // Store the matching array from cnameData or an empty array
  //           agent: matchingAgentData || [], // Store the matching array from agentName or an empty array
  //           accountNumber: e,
  //         };
  //       } else {
  //         newData[rowIndex] = {
  //           ...newData[rowIndex],
  //           name: matchingCnameData || [], // Store the matching array from cnameData or an empty array
  //           agent: matchingAgentData || [], // Store the matching array from agentName or an empty array
  //           accountNumber: e,
  //         };
  //       }
  //       setTableData(newData);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error.message);
  //   }
  // };

  const fetchAccNoData = async (e, rowIndex, agCode) => {
    try {
      // ////////////////////console.log("eeeee====",e.target.value);

      const accValue = e.target.value;
      const response = await axios.get(
        `${apiBaseUrl}/main/findbyaccnotable/${dbCode}`,
        { params: { accNo: accValue } }
      );
      const fetchedData = response.data;
      ////////////////console.log();

      const newData = [...tableData];

      // Check if fetched data exists and is in the correct format
      if (Array.isArray(fetchedData) && fetchedData.length > 0) {
        const { accname, agent } = fetchedData[0]; // Assuming only one record is fetched

        // Find the corresponding array in cnameData based on accname
        const matchingCnameData = cnameData.find((item) => item[0] === accname);

        // Find the corresponding array in agentName based on agent
        const matchingAgentData = agentName.find(
          (item) => item[0] === parseInt(agentCode),
        );

        const matchingSchemeData = schemedatas.find(
          (item) => String(item.accno) === String(accValue),
        );
        //console.log("matchingSchemeData", matchingSchemeData);

        // Update the name and agent fields of the current row in tableData
        newData[rowIndex] = {
          ...newData[rowIndex],
          name: matchingCnameData || [],
          agent: matchingAgentData || [],
          accountNumber: filteredaccNo.find(
            (item) => String(item[1]) === String(accValue),
          ),
          schemeId: matchingSchemeData?.schemeId || "",
        };
        setTableData(newData);
        dispTotalWt(rowIndex + 1, accname);
        printTotalBalance(rowIndex + 1, accname);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
    }
  };

  const [showFindDialog, setShowFindDialog] = useState(false); // State for controlling the visibility of the find dialog
  const [findEntryNo, setFindEntryNo] = useState(""); // State to store the entry number entered in the find dialog
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [verifyPassword, setShowverifyPassword] = useState(false);

  const [selectedSlNo, setSelectedSlno] = useState("");

  // ////////////////////console.log(findEntryNo);
  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const openPrintDialog = () => {
    setShowPrintDialog(true);
  };

  const closePrintDialog = () => {
    setShowPrintDialog(false);
  };
  // const handleFind = () => {

  //   ////////////////////console.log("Finding entry number:", findEntryNo);
  //   closeFindDialog();
  // };
  const [firstEno, setFirstEno] = useState("");
  const [lastEno, setLastEno] = useState("");
  //////////////////////console.log(firstEno,lastEno);

  const fetchfirstandlast = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/topandlast/${parseInt(frmId)}/${dbCode}/${fyid}`,
      );
      if (response.status === 200) {
        setFirstEno(response.data[0].firstentryno);
        setLastEno(response.data[0].lastentryno);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  // ////////////////////console.log('accNo==',accNo);
  // ////////////////////console.log('accccc=',accNo.find((item) => item[0] === 10));

  const handleFindbyentrynumber = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindbyentryNo/${findEntryNo}/${parseInt(
          frmId,
        )}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        // ////////////////////console.log(foundData);
        //  ////////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm
            ? (
                parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)
              ).toFixed(roundOff)
            : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows

        //console.log("firstRowData", firstRowData);

        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),

          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc:
            firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(1, firstCust);
          printTotalBalance(1, firstCust);
        }

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  // ////////////////////console.log('formatted date',formatDate);

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }
    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deleterecbyentryno/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}?location=${getCleanLocationId(schemeRecInfoData.Location)}`,
      );
      if (response.status === 200) {
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Scheme deleted",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });
        alert("Entry Deleted Successfully!");
        // window.location.reload();
        handleClear();
      } else {
        console.error("Error deleting data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleFindprev = async (e) => {
    fetchfirstandlast();
    if (schemeRecInfoData.EntryNo > firstEno) {
      handleClearfind();
    }
    // else{
    //   return;
    // }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindprev/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}`,
      );

      //  ////////////////////console.log("response=",response.data);

      if (response.status === 200) {
        const foundData = response.data;

        //////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm
            ? (
                parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)
              ).toFixed(roundOff)
            : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),
          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc:
            firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(1, firstCust);
          printTotalBalance(1, firstCust);
        }

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleFindnext = async () => {
    handleClearfind();
    fetchfirstandlast();
    if (schemeRecInfoData.EntryNo < lastEno) {
      handleClearfind();
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindnext/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        // ////////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm
            ? (
                parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)
              ).toFixed(roundOff)
            : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),
          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc:
            firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(1, firstCust);
          printTotalBalance(1, firstCust);
        }

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindfirst = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindfirst/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        // ////////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm
            ? (
                parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)
              ).toFixed(roundOff)
            : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),
          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc:
            firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(1, firstCust);
          printTotalBalance(1, firstCust);
        }

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };

  const handleFindlast = async () => {
    handleClearfind();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindlast/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}`,
      );

      if (response.status === 200) {
        const foundData = response.data;
        // ////////////////////console.log("data =", foundData);
        const newData = foundData.map((row) => ({
          //  SINo: row.Srp_entryno,
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm
            ? (
                parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)
              ).toFixed(roundOff)
            : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0]; // Assuming SrInfo data is the same for all rows
        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),
          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc:
            firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });
        // sr_AppEnable:foundData.Address1 || foundData,

        // Add the new data to tableData
        setTableData((prevTableData) => [...newData, ...prevTableData]);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(1, firstCust);
          printTotalBalance(1, firstCust);
        }

        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
      } else {
        console.error("Error finding data:", response.data);
      }
    } catch (error) {
      console.error("Error:", error.message);
      //setDataFound(false);
    }
    closeFindDialog();
  };
  const handleCheckSlno = () => {
    const filteredTableData = tableData.filter((row) => {
      // Check if any of the fields in the row is not empty
      return Object.values(row).some((value) => value !== "");
    });
    const filteredTableDataLength = filteredTableData.length;
    return filteredTableDataLength;
  };

  const [accumulatedWt, setaccumulatedWt] = useState("");
  // ////////////////////console.log("accumulatedWt",accumulatedWt);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/totalweight/${
          tableData[selectedSlNo - 1 || 0].name[0]
        }/${dbCode}`,
      );
      //////////////////////console.log("res===",response.data);
      setaccumulatedWt(response.data[0].WeightDifference);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [dispWt, setdispWt] = useState("");
  const [dispTm, setdispTm] = useState("");

  // const dispTotalWt = async (index,e) => {
  //   // ////////////////////console.log("index===",index);
  // //   if(e.key==='Enter'||e.key==='Return')
  // //  {
  //    try {
  //     const response = await axios.get(
  //       // `${apiBaseUrl}/main/totalweight/${tableData[index - 1 || 0].name[0]}`
  //       `${apiBaseUrl}/main/totalweight/${e}`

  //     );
  //     var calcgm =0;
  //     // if (e.target.value !== "" || null) {
  //     //   const Rate = schemeRecInfoData.rate;
  //     //   //  ////////////////////console.log("log rate", Rate);
  //     //   if (Rate !== 0) {
  //     //      calcgm = (e.target.value / Rate).toFixed(3);
  //     //     //  ////////////////////console.log("calcgm===",calcgm);

  //     //   }

  //     // }
  //     // const totalWeight = parseFloat(response.data[0].WeightDifference||0) + parseFloat(calcgm);

  //     setdispWt(response.data[0].WeightDifference||0);
  //     // setdispWt(totalWeight.toFixed(3));

  //     // ////////////////////console.log("res===",response.data[0].WeightDifference);
  //     // ////////////////////console.log("parse=", parseFloat(response.data[0].WeightDifference));

  //     // ////////////////////console.log("wt===",calcgm);
  //     // ////////////////////console.log("parse2", parseFloat(calcgm));

  //     // ////////////////////console.log("totalgm=",dispWt);

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // // }
  // //   else{
  // //     return
  // //   }
  // };

  const dispTotalWt = async (index, e) => {
    try {
      const led = Array.isArray(e) ? e[0] : (e?.value ?? e?.Ledcode ?? e);
      if (!led) return;
      const response = await axios.get(
        `${apiBaseUrl}/main/totalweight/${led}/${dbCode}`
      );
      const wtDiff = response.data?.[0]?.WeightDifference || 0;
      setdispWt(wtDiff);
      setaccumulatedWt(wtDiff);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const printTotalBalance = async (index, e) => {
    try {
      const led = Array.isArray(e) ? e[0] : (e?.value ?? e?.Ledcode ?? e);
      if (!led) return;
      const response = await axios.get(
        `${apiBaseUrl}/main/recprintob/${led}/${dbCode}`
      );
      setdispTm(parseFloat(response.data?.[0]?.oldBalance || 0));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const removeRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(newTableData);
  };
  ////////////////////////////Import Data//////////////

  const handleImportData = (importedData) => {
    // Clear existing data
    handleClear();
    //////////console.log("importedData===", importedData);

    // Create new rows for each imported account
    const newTableData = importedData.map((account, index) => ({
      SINo: index + 1,
      name: cnameData.find((item) => item[1] === account.name), // Format needed for ComboBox
      agent: agentName.find((item) => item[0] === parseInt(agentCode)) || [],
      accountNumber: accNo.find((item) => item[1] === account.accNo) || [],
      amount: account.totalAmount.toFixed(roundOff),
      disc: "",
      total: account.totalAmount.toFixed(roundOff),
      gm: "",
      discGm: "",
      totalGm: "",
      narration: "Imported from daily receipt",
      printgm: 1,
    }));

    // Add empty rows after the imported data with unique object instances
    const emptyRows = Array.from({ length: 14 - newTableData.length }, () => ({
      SINo: "",
      name: "",
      agent: "",
      accountNumber: "",
      amount: "",
      disc: "",
      total: "",
      gm: "",
      discGm: "",
      totalGm: "",
      narration: "",
      printgm: "",
    }));

    setTableData([...newTableData, ...emptyRows]);

    // Focus on the first row's narration field
    setRowIndex(0);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowsettings(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    // <div className="regmodal-overlay">
    <div
      className=" bg-white
        font-Poppins
        w-[95%]
        h-[90%]
        lg:w-[980px]
        lg:h-[500px]
        xl:w-[1030px]
        max-h-[600px]
       max-w-[1030px]
        rounded-lg
        shadow-md
        flex
        flex-col
        items-center
        absolute
        transition-all
        duration-300
        overflow-hidden"
      style={{ zIndex }}
    >
      <style>{`
        .schRecTableColBorder {
          border-bottom: 1px solid #ccc;
          border-right: 1px solid #ccc;
          box-sizing: border-box;
        }
        .schRecTableColBorderTransparent {
          border-right: 1px solid transparent;
          box-sizing: border-box;
        }
        .schRecInputBorder {
          border: 1px solid rgb(74, 74, 74);
          box-sizing: border-box;
        }
      `}</style>
      <WindowHeader
        title={fname || "Scheme Cash Receipt"}
        logo={headeLogo}
        onClose={() => {
          onClose();
          setfrmid("");
          setfname("");
        }}
        style={{ height: "30px" }}
        className="bg-[#0f56d3] text-white"
        titleClassName="text-xs"
        closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2 flex items-center justify-center"
      />

      {/*............................ ActionToolbar.............................................. */}
      <ActionToolbar
        width="100%"
        height="auto"
        size="small"
        iconSize={14}
        navBgColor="#0f56d3"
        navIconColor="#ffffff"
        buttonGap="5px"
        arrowGap="2%"
        saveBtnId="SaveBtn"
        printBtnId="PrintBtn"
        clearBtnId="ClearBtn"
        findBtnId="FindBtn"
        editBtnId="EditBtn"
        deleteBtnId="DeleteBtn"
        exitBtnId="ExitBtn"
        showSave={isFieldVisible("SaveBtn")}
        showPrint={isFieldVisible("PrintBtn")}
        showClear={isFieldVisible("ClearBtn")}
        showFind={isFieldVisible("FindBtn")}
        showEdit={isFieldVisible("EditBtn")}
        showDelete={isFieldVisible("DeleteBtn")}
        showExit={isFieldVisible("ExitBtn")}
        showNavigation={true}
        saveDisabled={isFieldDisabled("SaveBtn") || saveDisabled}
        editDisabled={isFieldDisabled("EditBtn") || editDisabled}
        deleteDisabled={isFieldDisabled("DeleteBtn") || deleteDisabled}
        dataFound={!editDisabled}
        permissions={permissions}
        permissionKey="schemecashReceipt"
        onSave={handleSave}
        onPrint={openPrintDialog}
        onClear={handleClear}
        onFind={openFindDialog}
        onEdit={handleVerifyPassword}
        onDelete={handleDelete}
        onExit={() => {
          onClose();
          setfrmid("");
          setfname("");
        }}
        onFirst={handleFindfirst}
        onPrevious={handleFindprev}
        onNext={handleFindnext}
        onLast={handleFindlast}
        showSettingsBar={true}
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
        settingsOptions={[
          {
            label: "Import from Daily receipt",
            onClick: () => setShowImportRec(true),
          },
          {
            label: "Transfer Pv",
            onClick: () => setShowTransfervoucher(true),
          },
          {
            label: "Design Columns",
            onClick: () => setShowGridDesignModal(true),
          },
          {
            label: "Form Design",
            onClick: () => setShowFormDesignModal(true),
          },
        ]}
        onRefsUpdate={(refs) => {
          if (refs.saveButtonRef && refs.saveButtonRef.current) {
            saveButtonRef.current = refs.saveButtonRef.current;
            registerRef("SaveBtn")(refs.saveButtonRef.current);
          }
          if (refs.editButtonRef && refs.editButtonRef.current) {
            editButtonRef.current = refs.editButtonRef.current;
            registerRef("EditBtn")(refs.editButtonRef.current);
          }
        }}
      />
      {/*............................ ActionToolbarEnd.............................................. */}
      {/*............................ NavbarEnd.............................................. */}

      <div className="w-full flex-grow h-0 flex items-center justify-center">
        <div className="h-full flex flex-col w-[95%]">
          <div className="w-full h-[15%] flex">
            <div className="h-full flex flex-col w-1/4">
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left" style={getLabelStyle("EntryNo")}>
                  Entry No
                </label>
                <input
                  ref={(el) => {
                    registerRef("EntryNo")(el);
                    entryNoInputRef.current = el;
                  }}
                  readOnly
                  style={{ textAlign: "center", ...getInputStyle("EntryNo") }}
                  className="schRecInputBorder px-1 w-[55%] h-5"
                  value={schemeRecInfoData.EntryNo}
                  onKeyDown={(e) => handleKeyDown(e, "EntryNo")}
                  onChange={(e) =>
                    setschemeRecInfoData({
                      ...schemeRecInfoData,
                      EntryNo: e.target.value,
                    })
                  }
                />
              </div>
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left" style={getLabelStyle("SchemeName")}>
                  Scheme Name
                </label>

                <ComboBox
                  findedValue={
                    Array.isArray(schemeRecInfoData.schemeId)
                      ? schemeRecInfoData.schemeId[1]
                      : schemeRecInfoData.schemeId
                  }
                  comboRef={(el) => {
                    registerRef("SchemeName")(el);
                    schemIdinputRef.current = el;
                  }}
                  options={schemeNames}
                  className="w-[55%] h-5"
                  inputClassName="p-1"
                  inlineStyles={getInputStyle("SchemeName")}
                  onKeyDown={(e) => {
                    handleKeyDown(e, "SchemeName");
                  }}
                  onInputChange={(e) => {
                    handleSchemeChange(e);
                  }}
                />
              </div>
            </div>
            <div className="h-full flex flex-col w-1/2 pl-[3%]">
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left text-nowrap" style={getLabelStyle("CashAccount")}>
                  Select Cash A/C
                </label>
                <ComboBox
                  findedValue={
                    Array.isArray(schemeRecInfoData.cashAcc)
                      ? schemeRecInfoData.cashAcc[1]
                      : schemeRecInfoData.cashAcc
                  }
                  comboRef={(el) => {
                    registerRef("CashAccount")(el);
                    cashaccinputRef.current = el;
                  }}
                  options={selectcashAcc}
                  className="w-[55%] h-5"
                  inputClassName="p-1"
                  inlineStyles={getInputStyle("CashAccount")}
                  onKeyDown={(e) => {
                    handleKeyDown(e, "CashAccount");
                    checkledgerExists(e);
                  }}
                  onInputChange={(e) =>
                    setschemeRecInfoData({ ...schemeRecInfoData, cashAcc: e })
                  }
                />
              </div>
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left" style={getLabelStyle("Rate")}>
                  Rate
                </label>
                <input
                  value={schemeRecInfoData.rate}
                  type="number"
                  ref={(el) => {
                    registerRef("Rate")(el);
                    rateInputRef.current = el;
                  }}
                  style={{ textAlign: "right", ...getInputStyle("Rate") }}
                  className="schRecInputBorder px-1 w-[55%] h-5"
                  onKeyDown={(e) => handleKeyDown(e, "Rate")}
                  onChange={(e) =>
                    setschemeRecInfoData({
                      ...schemeRecInfoData,
                      rate: e.target.value,
                    })
                  }
                  readOnly={
                    userType === "EMPLOYEE" && genValues?.readonlyGrate === 1
                  }
                />
              </div>
            </div>
            <div className="h-full flex flex-col w-1/4">
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left" style={getLabelStyle("Date")}>
                  Date
                </label>
                <input
                  value={schemeRecInfoData.date}
                  type="date"
                  min={minDate}
                  max={maxDate}
                  ref={(el) => {
                    registerRef("Date")(el);
                    dateInputRef.current = el;
                  }}
                  style={getInputStyle("Date")}
                  className="schRecInputBorder px-1 w-[55%] h-5"
                  onKeyDown={(e) => handleKeyDown(e, "Date")}
                  onChange={(e) => {
                    setschemeRecInfoData({
                      ...schemeRecInfoData,
                      date: e.target.value,
                    });
                  }}
                  onBlur={(e) => {
                    const val = e.target.value;
                    if (val && !isDateInFy(val)) {
                      alert("Date incompatible with financial year");
                    }
                  }}
                  readOnly={
                    userType === "EMPLOYEE" && genValues?.readonlyDate === 1
                  }
                />
              </div>
              <div className="w-full h-1/2 flex gap-[3%] items-center">
                <label className="font-Inter text-black text-xs font-semibold w-[35%] text-left text-nowrap">
                  Sales Man
                </label>
                <ComboBox
                  options={Billers}
                  comboRef={salesmanRef}
                  className="w-[55%] h-5"
                  inputClassName="p-1"
                  onInputChange={(value) => {
                    setschemeRecInfoData((prev) => ({
                      ...prev,
                      salesMan: value,
                    }));
                    let selectedAgentId = null;
                    if (Array.isArray(value) && value.length > 0) {
                      selectedAgentId = value[0];
                    } else if (value) {
                      const match = Billers.find((item) => String(item[1]).toLowerCase() === String(value).toLowerCase() || String(item[0]) === String(value)) ||
                                    agentName.find((item) => String(item[1]).toLowerCase() === String(value).toLowerCase() || String(item[0]) === String(value));
                      if (match) selectedAgentId = match[0];
                    }
                    if (selectedAgentId) {
                      fetchcashAcc(selectcashAcc, selectedAgentId);
                    }
                  }}
                  findedValue={
                    Array.isArray(schemeRecInfoData.salesMan)
                      ? schemeRecInfoData.salesMan[1]
                      : schemeRecInfoData.salesMan
                  }
                />
              </div>
            </div>
          </div>

          {/*---------------- receipt data table.----------------------- */}

          <div
            className="schRecDataTable font-Inter w-full shrink-0 flex flex-col text-black text-[10px] font-semibold leading-normal overflow-auto mt-2 flex-grow h-0 min-h-[140px]"
            ref={tableContainerRef}
            style={{
              border: "1px solid #ccc",
              boxSizing: "border-box",
              height: "0px",
              flexGrow: 1,
              flexShrink: 1,
              maxHeight: "300px",
            }}
          >
            {/* Header row */}
            <div
              style={{ height: "35px", flexShrink: 0 }}
              className="w-max min-w-full bg-[#026CC3] flex text-white text-xs font-medium sticky top-0 z-20"
            >
              {gridColumns.map((col) => {
                if (!col.show) return null;
                return (
                  <div
                    key={col.columnName}
                    style={{ width: `${col.width}px`, flexShrink: 0 }}
                    className="h-full schRecTableColBorder flex items-center justify-center text-center"
                  >
                    {col.header}
                  </div>
                );
              })}
              <div
                style={{ width: "40px", flexShrink: 0 }}
                className="h-full schRecTableColBorder flex items-center justify-center"
              ></div>
            </div>

            {/* Body rows */}
            <div className="w-full h-max flex flex-col flex-grow">
              {tableData.map((rowData, rowIndex) => {
                const handleGridKeyDown = createGridKeyDownHandler({
                  rowIndex, breakoutColumn, rowBreakColumn, rowBreakTarget,
                  formFields, addRow, focusField, handleDynamicKeyDown,
                });

                return (
                  <div
                    key={rowIndex}
                    className="schRecTbodyRow w-max min-w-full h-[3rem] bg-white flex flex-col"
                  >
                    {/* Upper Section (Main inputs) */}
                    <div className="schRecRow w-max min-w-full h-1/2 bg-white flex hover:bg-blue-50/30">
                      {gridColumns.map((col) => {
                        if (!col.show) return null;
                        const cellWidth = `${col.width}px`;
                        const colStyle = { width: cellWidth, flexShrink: 0 };
                        const cellClass = "h-full schRecTableColBorder p-[1px] flex items-center";

                        const renderCell = {
                          Slno: () => (
                            <div key={col.columnName} style={colStyle} className="h-full schRecTableColBorder flex items-center justify-center text-center">
                              {rowIndex + 1}
                            </div>
                          ),
                          ItemName: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <ComboBox
                                findedValue={
                                  Array.isArray(tableData[rowIndex]?.name)
                                    ? (tableData[rowIndex]?.name?.[1] ?? "")
                                    : tableData[rowIndex]?.name
                                }
                                options={cnameData}
                                className="w-full h-full border-none"
                                inputClassName="border-none outline-none w-full h-full px-1 text-xs"
                                comboRef={registerRef(`grid_${rowIndex}_ItemName`)}
                                onKeyDown={(e) => {
                                  handleDynamicKeyDown(e, `grid_${rowIndex}_ItemName`);
                                  checkNameExists(e);
                                }}
                                onInputChange={(e) => handleCellChange(e, rowIndex, "name")}
                              />
                            </div>
                          ),
                          Agent: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <ComboBox
                                findedValue={
                                  Array.isArray(tableData[rowIndex]?.agent)
                                    ? (tableData[rowIndex]?.agent?.[1] ?? "")
                                    : tableData[rowIndex]?.agent
                                }
                                options={agentName}
                                className="w-full h-full border-none"
                                inputClassName="border-none outline-none w-full h-full px-1 text-xs"
                                comboRef={registerRef(`grid_${rowIndex}_Agent`)}
                                onKeyDown={(e) => handleDynamicKeyDown(e, `grid_${rowIndex}_Agent`)}
                                onInputChange={(e) => handleCellChange(e, rowIndex, "agent")}
                                readOnly={true}
                              />
                            </div>
                          ),
                          AccountNumber: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <ComboBox
                                findedValue={
                                  Array.isArray(tableData[rowIndex]?.accountNumber)
                                    ? (tableData[rowIndex]?.accountNumber?.[1] ?? "")
                                    : tableData[rowIndex]?.accountNumber
                                }
                                options={filteredaccNo}
                                className="w-full h-full border-none"
                                inputClassName="border-none outline-none w-full h-full px-1 text-xs"
                                comboRef={registerRef(`grid_${rowIndex}_AccountNumber`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "AccountNumber")}
                                onInputChange={(e) => handleCellChange(e, rowIndex, "accountNumber")}
                                onBlur={(e) => fetchAccNoData(e, rowIndex, agentCode)}
                              />
                            </div>
                          ),
                          Amount: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                value={tableData[rowIndex]?.amount || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_Amount`)}
                                onChange={(e) => {
                                  handleCellChangeinput(e, rowIndex, "amount");
                                  calculateRowTotalAndGms(rowIndex);
                                }}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs"
                                onKeyDown={(e) => handleGridKeyDown(e, "Amount")}
                                onBlur={() => calculateRowTotalAndGms(rowIndex)}
                              />
                            </div>
                          ),
                          Disc: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                value={tableData[rowIndex]?.disc || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_Disc`)}
                                onChange={(e) => {
                                  handleCellChangeinput(e, rowIndex, "disc");
                                  calculateRowTotalAndGms(rowIndex);
                                }}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs"
                                onKeyDown={(e) => handleGridKeyDown(e, "Disc")}
                                onBlur={() => calculateRowTotalAndGms(rowIndex)}
                              />
                            </div>
                          ),
                          Total: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                readOnly
                                value={tableData[rowIndex]?.total || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_Total`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "Total")}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs bg-transparent"
                              />
                            </div>
                          ),
                          Gm: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                readOnly
                                value={tableData[rowIndex]?.gm || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_Gm`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "Gm")}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs bg-transparent"
                              />
                            </div>
                          ),
                          DiscGm: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                readOnly
                                value={tableData[rowIndex]?.discGm || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_DiscGm`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "DiscGm")}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs bg-transparent"
                              />
                            </div>
                          ),
                          TotalGm: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                readOnly
                                value={tableData[rowIndex]?.totalGm || ""}
                                style={{ textAlign: "right" }}
                                ref={registerRef(`grid_${rowIndex}_TotalGm`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "TotalGm")}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs bg-transparent"
                              />
                            </div>
                          ),
                          Narration: () => (
                            <div key={col.columnName} style={colStyle} className={cellClass}>
                              <input
                                value={tableData[rowIndex]?.narration || ""}
                                className="w-full h-[22px] border-none outline-none px-1 text-xs"
                                ref={registerRef(`grid_${rowIndex}_Narration`)}
                                onKeyDown={(e) => handleGridKeyDown(e, "Narration")}
                                onChange={(e) => handleCellChangeinput(e, rowIndex, "narration")}
                              />
                            </div>
                          ),
                          PrintGm: () => (
                            <div key={col.columnName} style={colStyle} className="h-full schRecTableColBorder flex items-center justify-center">
                              <input
                                checked={tableData[rowIndex]?.printgm === 1}
                                type="checkbox"
                                onChange={(e) => handleCellChangeinput(e, rowIndex, "printgm")}
                                className="w-4 h-4 cursor-pointer"
                              />
                            </div>
                          ),
                        };

                        const renderer = renderCell[col.columnName];
                        if (renderer) return renderer();
                        return (
                          <div key={col.columnName} style={colStyle} className="h-full schRecTableColBorder"></div>
                        );
                      })}
                    <div
                      style={{ width: "40px", flexShrink: 0 }}
                      className="h-full schRecTableColBorder flex items-center justify-center cursor-pointer hover:bg-red-50"
                      onClick={() => removeRow(rowIndex)}
                    >
                      <img src={binImg} alt="binImg" className="w-4 h-4" />
                    </div>
                  </div>

                  {/* Lower Section (Gray Spacer) */}
                  <div className="w-max min-w-full h-1/2 bg-[#EBEBEB] flex sticky border-b border-[#ccc]">
                    {gridColumns.map((col) => {
                      if (!col.show) return null;
                      return (
                        <div
                          key={col.columnName}
                          style={{ width: `${col.width}px`, flexShrink: 0 }}
                          className="h-full"
                        />
                      );
                    })}
                    <div
                      style={{ width: "40px", flexShrink: 0 }}
                      className="h-full"
                    />
                  </div>
                </div>
              );
            })}
          </div>

            <div
              style={{
                width: "max-content",
                minWidth: "100%",
                display: "flex",
                alignItems: "center",
                height: "26px",
                position: "sticky",
                bottom: 0,
                zIndex: 30,
              }}
              className="schRecDataTablefootertotal bg-[#026CC3] text-white font-medium"
            >
              {/* Combined first 4 columns */}
              <div
                style={{
                  width: `${
                    (gridColumns.find((c) => c.columnName === "Slno")?.show
                      ? getColWidth("Slno")
                      : 0) +
                    (gridColumns.find((c) => c.columnName === "ItemName")?.show
                      ? getColWidth("ItemName")
                      : 0) +
                    (gridColumns.find((c) => c.columnName === "Agent")?.show
                      ? getColWidth("Agent")
                      : 0) +
                    (gridColumns.find((c) => c.columnName === "AccountNumber")
                      ?.show
                      ? getColWidth("AccountNumber")
                      : 0)
                  }px`,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  paddingLeft: "10px",
                  flexShrink: 0,
                  height: "100%",
                }}
                className="schRecTableColBorderTransparent"
              >
                <div className="flex items-center gap-1">
                  <label className="font-Inter text-white text-xs">CW</label>
                  <input
                    value={dispWt}
                    className="bg-white border-none h-5 px-1 w-20 text-right text-black text-xs"
                    readOnly
                  />
                </div>
                <div className="flex items-center gap-1">
                  <label className="font-Inter text-white text-xs">CB</label>
                  <input
                    value={dispTm}
                    className="bg-white border-none h-5 px-1 w-20 text-right text-black text-xs"
                    readOnly
                  />
                </div>
              </div>

              {/* Map remaining columns starting from Amount */}
              {gridColumns.map((col) => {
                if (!col.show) return null;
                if (["Slno", "ItemName", "Agent", "AccountNumber"].includes(col.columnName))
                  return null;
                const cellWidth = `${col.width}px`;
                const footerColStyle = { width: cellWidth, flexShrink: 0, height: "100%" };
                const footerCellClass = "schRecTableColBorderTransparent flex items-center py-[2px]";
                const footerInputClass = "bg-white border-none text-black text-[10px] font-semibold px-1 w-full h-[22px]";

                const renderFooterCell = {
                  Amount: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Total Amount" value={schemeRecInfoData.totalamt} readOnly className={footerInputClass} />
                    </div>
                  ),
                  Disc: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Total Discount" value={schemeRecInfoData.totalDisc} readOnly className={footerInputClass} />
                    </div>
                  ),
                  Total: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Grand Total Amount" value={schemeRecInfoData.totalamtdisc} readOnly className={footerInputClass} />
                    </div>
                  ),
                  Gm: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Total Amount Gm" value={schemeRecInfoData.totalgm} readOnly className={footerInputClass} />
                    </div>
                  ),
                  DiscGm: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Total Discount Gm" value={schemeRecInfoData.totaldiscgm} readOnly className={footerInputClass} />
                    </div>
                  ),
                  TotalGm: () => (
                    <div key={col.columnName} style={footerColStyle} className={footerCellClass}>
                      <input style={{ textAlign: "right" }} title="Grand Total Gm" value={schemeRecInfoData.totalTotalGm} readOnly className={footerInputClass} />
                    </div>
                  ),
                };

                const renderer = renderFooterCell[col.columnName];
                if (renderer) return renderer();
                return <div key={col.columnName} style={footerColStyle} className="schRecTableColBorderTransparent" />;
              })}
              <div
                style={{ width: "40px", flexShrink: 0, height: "100%" }}
                className="schRecTableColBorderTransparent"
              />
            </div>
          </div>
        </div>
      </div>

      {showFindDialog && (
        <div className="find-dialog">
          <input
            type="text"
            value={findEntryNo}
            onChange={(e) => setFindEntryNo(e.target.value)}
            placeholder="Enter Entry No"
          />
          <button onClick={handleFindbyentrynumber}>Find</button>

          <div
            className="findCloseDiv"
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}

      {showPrintDialog && (
        <div
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: (zIndex || 100) + 10,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 8px 40px rgba(0,0,0,0.22)",
              padding: "28px 32px",
              minWidth: "320px",
              display: "flex",
              flexDirection: "column",
              gap: "14px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "4px" }}>
              <span style={{ fontWeight: 700, fontSize: "15px", color: "#0f2d59" }}>🖨️ Print Receipt</span>
              <button
                onClick={closePrintDialog}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#64748b", lineHeight: 1 }}
              >✕</button>
            </div>

            {/* Sl No Input */}
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Row Sl No</label>
              <input
                type="number"
                min="1"
                value={selectedSlNo}
                onChange={(e) => setSelectedSlno(e.target.value)}
                placeholder="e.g. 1"
                autoFocus
                style={{
                  border: "1.5px solid #cbd5e1", borderRadius: "7px",
                  padding: "7px 12px", fontSize: "13px", outline: "none",
                  width: "100%", boxSizing: "border-box",
                }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "4px" }}>
              {/* Print */}
              <button
                disabled={isPrintLoading}
                onClick={() => handleDynamicAction("print")}
                style={{
                  background: isPrintLoading ? "#94a3b8" : "linear-gradient(135deg,#0f56d3,#0f2d59)",
                  color: "#fff", border: "none", borderRadius: "8px",
                  padding: "10px 16px", fontSize: "13px", fontWeight: 600,
                  cursor: isPrintLoading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  transition: "opacity 0.2s",
                }}
              >
                🖨️ {isPrintLoading ? "Generating..." : "Print Receipt"}
              </button>

              {/* Download PDF */}
              <button
                disabled={isPrintLoading}
                onClick={() => handleDynamicAction("download")}
                style={{
                  background: isPrintLoading ? "#94a3b8" : "linear-gradient(135deg,#059669,#065f46)",
                  color: "#fff", border: "none", borderRadius: "8px",
                  padding: "10px 16px", fontSize: "13px", fontWeight: 600,
                  cursor: isPrintLoading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  transition: "opacity 0.2s",
                }}
              >
                📥 {isPrintLoading ? "Generating..." : "Download PDF"}
              </button>
            </div>

            {isPrintLoading && (
              <p style={{ textAlign: "center", fontSize: "11px", color: "#94a3b8", margin: 0 }}>
                Building PDF from template…
              </p>
            )}
          </div>
        </div>
      )}

      {verifyPassword && (
        <AdminVerification
          onClose={() => {
            setShowverifyPassword(false);
          }}
          onVerified={(value) => handleEdit(value)}
        />
      )}

      {showPrintModel && (
        <Print
          printData={printData}
          onClose={handleClosePrint}
          totalwt={accumulatedWt}
        />
      )}

      {showImportRec && (
        <ImportReceipt
          onClose={() => {
            setShowImportRec(false);
            handleClear();
          }}
          onImport={handleImportData}
          fId={parseInt(frmId)}
        />
      )}

      {showTransfervoucher && (
        <TransferVoucher
          onClose={() => {
            setShowTransfervoucher(false);
            handleClear();
          }}
          onImport={handleImportData}
          fId={parseInt(frmId)}
        />
      )}

      {showGridDesignModal && (
        <GridDesign
          onClose={() => setShowGridDesignModal(false)}
          onSave={(updatedCols) => {
            setGridColumns(updatedCols);
          }}
          formName={vType}
          initialColumns={defaultSchemeGridColumns}
        />
      )}

      {showFormDesignModal && (
        <FormDesign
          onClose={() => setShowFormDesignModal(false)}
          formName={vType || "SCHEME RECEIPT"}
          initialFields={defaultSchemeFormFields}
          zIndex={zIndex}
          highlightFieldId={activeFieldId}
          onSave={(updatedFields) => {
            setFormFields(updatedFields);
            // Sync row-break and breakout config values into context immediately
            const rowBreakColField = updatedFields.find(
              (f) => f.fieldId === "__GridRowBreakColumn",
            );
            const rowBreakTgtField = updatedFields.find(
              (f) => f.fieldId === "__GridRowBreakTarget",
            );
            const breakoutColField = updatedFields.find(
              (f) => f.fieldId === "__GridBreakoutColumn",
            );
            const breakoutTgtField = updatedFields.find(
              (f) => f.fieldId === "__GridBreakoutTarget",
            );
            if (rowBreakColField?.defaultValue)
              setRowBreakColumn(rowBreakColField.defaultValue);
            if (rowBreakTgtField?.defaultValue)
              setRowBreakTarget(rowBreakTgtField.defaultValue);
            if (breakoutColField?.defaultValue)
              setBreakoutColumn(breakoutColField.defaultValue);
            if (breakoutTgtField?.defaultValue)
              setBreakoutTarget(breakoutTgtField.defaultValue);
          }}
        />
      )}
    </div>
    // </div>
  );
}

export default SchemeCashReceipt;
